import * as React from "react";
import { useRef } from "react";
import {Checkbox, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box,AppBar,Select,Toolbar, FormControl, InputLabel, Card, CardContent, Link, Badge, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, tableCellClasses } from "@mui/material";

import {echoStatusButton ,echoStatusLabel , echoTabName,monthsName, callByItems} from "../../../../constants"
import Sidebar from './../../common/sidebar/index'
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { MyContext } from "../../../pages/liveChat";
import axios from "axios";
import { styled, useTheme } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import TextField from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TimestampConverter from "./timeStampConvertor";
import { ToastContainer, toast } from "react-toastify";
import Alert from "@mui/material/Alert";
import { parseInstituteHash, makeInstituteHash, getInfra, prepareAJAXData ,maskEmailsInString,encryptText, getLeadIdForCopy} from "../../../../common";
import { getBaseUrl } from "../../../../environment";
import useWebSocket from "react-use-websocket";
import WebSocket from "websocket";
import NameLetter from "../../common/nameLetter";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import SendIcon from "@mui/icons-material/Send";
import MicIcon from "@mui/icons-material/Mic";
import SessionTimer from "./sessionTimer";

import ImageMessage from "./imageMessage";
import VideoMessage from "./videoMessage";
import AudioMessage from "./audioMessage";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import VideoCameraBackIcon from "@mui/icons-material/VideoCameraBack";
import ListItemIcon from "@mui/material/ListItemIcon";
import ScrollableFeed from "react-scrollable-feed";
import InfiniteScroll from "react-infinite-scroller";
import { useWebSocketContext } from "../../../pages/liveChat/webSocketConnection";
import xlsxImg from "../../../assets/images/attachment/xlsx.svg";
import xlsImg from "../../../assets/images/attachment/xls.svg";
import pdfImg from "../../../assets/images/attachment/pdf.svg";
import docImg from "../../../assets/images/attachment/doc.svg";
import docxImg from "../../../assets/images/attachment/docx.svg";
import pptxImg from "../../../assets/images/attachment/pptx.svg";
import txtImg from "../../../assets/images/attachment/txt.svg";

import csvImg from "../../../assets/images/attachment/csv.svg";
import jpegImg from "../../../assets/images/attachment/jpeg.svg";
import jpgImg from "../../../assets/images/attachment/jpg.svg";
import pngImg from "../../../assets/images/attachment/png.svg";
import gifImg from "../../../assets/images/attachment/gif.svg";
import odtImg from "../../../assets/images/attachment/odt.svg";
import zipImg from "../../../assets/images/attachment/zip.svg";
import mp4Img from "../../../assets/images/attachment/mp4.svg";
import mpegImg from "../../../assets/images/attachment/mpeg.svg";
import aviImg from "../../../assets/images/attachment/avi.svg";
import mkvImg from "../../../assets/images/attachment/mkv.svg";
import m1vImg from "../../../assets/images/attachment/m1v.svg";
import m2vImg from "../../../assets/images/attachment/m2v.svg";
import movImg from "../../../assets/images/attachment/mov.svg";
import divxImg from "../../../assets/images/attachment/divx.svg";
import flvImg from "../../../assets/images/attachment/flv.svg";
import gpImg from "../../../assets/images/attachment/3gp.svg";
import m4vImg from "../../../assets/images/attachment/m4v.svg";

import defaultImg from "../../../assets/images/attachment/default.svg";

import whatsAppImg from "../../../assets/images/whatsApp.png";
import niaaImg from "../../../assets/images/niaa.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import Toast from "../../common/toast";
import AnnouncementIcon from '@mui/icons-material/Announcement';
import Chip from "@mui/material/Chip";
import ClearIcon from "@mui/icons-material/Clear";
import fileExtension from "file-extension";
import CircularProgress from '@mui/material/CircularProgress';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SearchIcon from "@mui/icons-material/Search";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText'; 
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RemoveIcon from '@mui/icons-material/Remove';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip,  { tooltipClasses } from '@mui/material/Tooltip';
import { triggerGtmAction } from "../../common/gtmConfiguration";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import ExtensionIcon from '@mui/icons-material/Extension';
import ArticleIcon from '@mui/icons-material/Article';
import { render } from "@testing-library/react";

import Snackbar from '@mui/material/Snackbar';
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import {
  deepOrange,
  lightBlue,
  red,
  lightGreen,
  amber,
  pink,
  teal,
  grey,
  cyan,
  green,
  indigo,
  blue,
} from "@mui/material/colors";
import "./chatHistory.scss";
import { Input } from "@mui/material";
import { parseJSON, setDefaultOptions } from "date-fns";
import { json } from "react-router-dom";
import NoDataFound from "../../common/noDataFound/noDataFound";
import EchoNotConfigured from "../../common/sidebar/EchoNotConfigured";
import LeadIdCopyButton from "./LeadIdCopyButton";
import CommentsDisabledOutlinedIcon from '@mui/icons-material/CommentsDisabledOutlined';
import { FastForward, PageviewOutlined, RawOff } from "@mui/icons-material";
import ToastAlert from "../../common/successToast";
import { darkTheme } from "../../common/Theme/darkTheme";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#222" : "#f1f1f1",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
}));
const drawerWidth = 360;

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    maxWidth: 630,
  },
}));


export default function ChatHistory({ changeAction, user }) {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const {
    candidate,
    setCandidate,
    chat,
    setChat,
    collegeId,
    instituteHash,
    collegeHash,
    fetchAgain,
    setFetchAgain,
    leadMessage,
    setLeadMessage,
    validateAuth,
    userDetails,
    errorMessageState,
    setErrorMessageState,
    tabVal,
    setTabVal,
    masking,
    callBy,
    collegeDialcode,
    appTheme
    } = React.useContext(MyContext);
  // const boxRef = React.useRef(null);
  // const [chat, setChat] = React.useContext(MyContext);
  const observer = React.useRef(null);
  const [page, setPage] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const [chatLoading, setChatLoading] = React.useState(false);
  const [templateModel, setTemplateModel] = React.useState(false);
  const [templatePreview, setTemplatePreview] = React.useState(null);
  // const [selectedTemplate, setSelectedTemplate] = React.useState(null);
  // const [templateMessage, setTemplateMessage] = React.useState(null);
  const [templateData, setTemplateData] = React.useState(null);
  // const [templateHtml, setTemplateHtml] = React.useState(null);
  // const [templateMediaName, setTemplateMediaName] = React.useState(null);
  const [templateList, setTemplateList] = React.useState([]);
  const [selectedWabaNo,setSelectedWabaNo] =React.useState('');
  const [lastWabaNoSt,setLastWabaNoSt] =React.useState('');
  const [wabaNos,setWabaNos] =React.useState([]);
  const containerRef = React.useRef(null);
  const [message, setMessage] = React.useState("");
  const [messageType, setMessageType] = React.useState("text");
  const [mediaUrl, setMediaUrl] = React.useState("");
  const [binaryData, setBinaryData] = React.useState(null);
  const [editor, setEditor] = React.useState(null);
  const [credits, setCredits] = React.useState(100);
  const [newMessage, setNewMessage] = React.useState("");
  const [typing, setTyping] = React.useState(false);
  const [istyping, setIsTyping] = React.useState(false);
  const [hasMoreData, setHasMoreData] = React.useState(true);
  const [session, setSession] = React.useState(0);
  const { sendMessage, lastMessage, readyState } = useWebSocketContext();
  const [enterShow, setEnterShow] = React.useState(false);
  const [searchTemplateNoData, setSearchTemplateNoData] = React.useState(false);
  const [chatHistoryHeight, setChatHistoryHeight] = React.useState();
  const [checkAnyEnableNo, setCheckAnyEnableNo] = React.useState(false);
  const [wabaAliasConfig, setWabaAliasConfig] = React.useState({});
  const [echoStatus, setEchoStatus] = React.useState('');
  const [conversationView, setConversationView] = React.useState('all');
  const [defaultConfig, setDefaultConfig] = React.useState('0');
  const [templateFilterValue,setTemplateFilterValue]=React.useState('');
  const [statusChangeLoading,setStatusChangeLoading]=React.useState(false);
  const [tempWabaNo,setTempWabaNo]=React.useState(false);
  const [tempSession,setTempSession]=React.useState(false);
  const [sessionTime, setSessionTime] = React.useState({ hours: 0, minutes: 0,seconds: 0,});
  const [templateLoder,setTemplateLoder]=React.useState(false);
  const [toggleMinIcon, setToggleMinIcon] = React.useState(false);
  const [newMsgBlink, setNewMsgBlink] = React.useState(false);
  const [uploadModel, setUploadModel] =React.useState(false);
  const [uploadFields, setUploadFields] =React.useState(false);
  const [fieldSearch, setFieldSearch] =React.useState('');
  const [uploadFileInfo , setUploadFileInfo] = React.useState('');
  const [fileUrl, setFileUrl] = React.useState('');
  const [selectedUploadField,setSelectedUploadField] = React.useState('')
  const [binaryDataForLm, setBinaryDataForLm] = React.useState(null);
  const [openAttachment, setOpenAttachment] = React.useState({});
  const [uploadLoader, setUploadLoader] = React.useState(false);
  const theme = useTheme();
  const inputRef = useRef(null);
  const fileInputRefDoc = React.useRef(null);
  const fileInputRefImg = React.useRef(null);
  const fileInputRefVid = React.useRef(null);
  const fileInputRefAttachment = React.useRef(null);
  const [chatHistoryLoading, setChatHistoryLoading] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");
  const [attachmentModal,setAttachmentModal]=React.useState(false);
  const matches = useMediaQuery("(min-width:768px)");
  const [sendDisabled, setSendDisabled] = React.useState(false);
  /** From chat-history API: `echo_enabled: false` when Echo is off; key omitted when on. */
  const [echoEnabled, setEchoEnabled] = React.useState(true);
  const mobileMatches = useMediaQuery('(max-width:600px)');
  const messagesEndRef = React.useRef(null);
  var yesterdayDate=''
  var currentDate=''
  var displayDateFlag=''
  var zindexOfDate=0;
  var groupMsgSide=''
  var groupMsgWabaNo=''
  var preMsgDate=''
  var lastsendertype=''
  var lastSendor=''
  const sendMessage1 = async () => {
    if(selectedWabaNo == ' ' || selectedWabaNo == '' || selectedWabaNo ==null){
      setErrorMessageState(() => true);
    setToastMessage({msg:'Please select WABA Number to send message from',severity:"error"});
     setSendDisabled(()=>false)
     return false
  }
    // var temData=selectedTemplate?selectedTemplate:templatePreview;
    var temData=templatePreview;

    try {
      setSendDisabled(()=>true)
      const isAuthenticated = await validateAuth();
      if (!isAuthenticated) {
        return alert("Please login to portal");
      }

      const { infra, institute_hash } = getInfra();
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);

      if (messageType == "text" && temData == null) {
        if (!message.trim()) {
          console.log("Message is required for textsendMessage type");
          return;
        }
      }

      let mediaUrl = "";
      let file_id = "";
      let file_size = '';
      if (binaryData) {
        const formData = new FormData();
        formData.append("file", binaryData);
        let preData=prepareAJAXData({room_id: `cr_${candidate.id}`,
                                  collegeId: collegeId,
                                  user_id:userDetails.EntityId,
                                  candidateId:candidate.id,
                                  url:`${meritto_service_url}/communication/v1/${collegeId}/live-chat-s3-upload`})
        formData.append(
          "incData",
          preData.data
        );
        const post_data = formData;
        const awsResponse = await axios.post(
          `${meritto_node_url}/chat/${collegeHash}/uploadDataToS3`,
          post_data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (awsResponse.status === 200) {
          if(awsResponse.data && awsResponse.data.status == 500){
            setErrorMessageState(() => true);
            setToastMessage( {msg:awsResponse.data.message,severity:"error"});
            setSendDisabled(()=>false)
            setMessage("");
            setBinaryData(null);
            setMessageType('text')
            setEnterShow(false)
            var screenWidth= window.innerWidth;
            // if(screenWidth > 767){
            //   setChatHistoryHeight(141)
            // }else{
            //   setChatHistoryHeight(125)
            // }
            chatHistoryHeightFunc(true)
            return false
          }
          mediaUrl = awsResponse?.data.media_url;
          file_id = awsResponse?.data.file_id;
          file_size = binaryData?.size;
        }else {
          throw new Error("error while uploading");
        }
      }
      setBinaryData(null);

      // const post_data = prepareAJAXData({
      //   room_id: `cr_${candidate.id}`,
      //   sender_id: String(userDetails?.UserId),
      //   sender_type: "user",
      //   sender_name: userDetails?.Name,
      //   receiver_id: String(candidate.id),
      //   receiver_dial_code: countryDialCode,
      //   receiver_mobile_no: chatMobileNo,
      //   message_type: temData ? "template":messageType,
      //   template_id: temData ? temData.id:0,
      //   message:  temData && temData.template_category  &&  temData.template_category != "canned" ? (templateData.message?templateData.message:"hello"):message,
      //   media_url: templateMediaName && templateData && templateData.file_path ? templateData.file_path:'',
      //   // media_url: "",
      //   job_id: chat.length
      //     ? String(chat.slice(-1)[0].communication_log_id)
      //     : "0", ///last message job id
      //   whatsconfig_number: selectedWabaNo,
      //   template_category: temData ? temData.template_category:'',
      //   url: `${meritto_service_url}/communication/v1/${collegeId}/send-chat-message`,
      //   user: userDetails
      // }
      // );
      const effectiveDialcode = (candidate && candidate.country_dialcode) ? candidate.country_dialcode : collegeDialcode;
      const region = effectiveDialcode == collegeDialcode ? "national" : "international";
      let pojo = {
        room_id: `cr_${candidate.id}`,
        sender_id: String(userDetails?.UserId),
        sender_type: "user",
        sender_name: userDetails?.Name,
        receiver_id: String(candidate.id),
        receiver_dial_code: effectiveDialcode,
        receiver_mobile_no: candidate.m_token ? candidate.m_token :0,
        message_type: temData ? "template":messageType,
        template_id: temData ? temData.id:0,
        // message:  temData && temData.template_category  &&  temData.template_category != "canned" ? (templateData.message?templateData.message:"hello"):message,
        message:  temData && temData.template_category    ?templateData.message:message,

        media_url: templateData && templateData.file_path ? templateData.file_path:mediaUrl,
        // media_url: "",
        job_id: chat.length
          ? String(chat.slice(-1)[0].communication_log_id)
          : "0", ///last message job id
        whatsconfig_number: selectedWabaNo,
        template_category: temData ? temData.template_category:'',
        user_id:userDetails?.UserId,
        entity_id:userDetails?.EntityId,
        user_role:userDetails?.GroupId,
        masking:masking,
        region: region,
        url: `${meritto_service_url}/communication/v1/${collegeId}/send-chat-message`,
        user: userDetails
      }
      if(file_id){
        pojo['file_id'] = file_id
      }
      const post_data = prepareAJAXData(pojo)
      const response = await axios.post(
        // `${constants.MS_SERVICE_URL}/communication/v1/${collegeId}/send-chat-message`,
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      const chatData = response.data.data?.chat_data;
      if (response.data.data.error && !chatData) {
        throw new Error(response.data.data.error);
      }
      const newMessage1 = {
        room_id: chatData?.room_id,
        communication_log_id: chatData?.communication_log_id,
        body: chatData.body,
        created_at: chatData.created_at,
        from: chatData.from,
        name: chatData.name,
        sender_id: chatData.sender_id,
        sender_type: chatData.sender_type,
        // status: chatData.status,
        sender_name: userDetails?.Name,
        type: chatData.type,
        url: chatData.url,
        whatsconfig_number: selectedWabaNo,
        waba_number: selectedWabaNo,
      };
      if(chatData?.error || response.data.data.error){
        newMessage1.error = chatData?.error || response.data.data.error
      }
      if(file_id){
        newMessage1['file_id'] = file_id
        newMessage1['file_size']=file_size
      }
      
 
      sendMessage(
        JSON.stringify({
          type: "new message",
          newMessage: newMessage1,
          room_id: `cr_${candidate.id}`,
        })
      );
      setMessage("");
      setMediaUrl("");
      // setTemplateMediaName(null);
      setMessageType("text");
      setSendDisabled(()=>false)
      setChat((prevChat) => [...prevChat, newMessage1]);
      setEnterShow(false)
      setTemplateData(null);
      var screenWidth= window.innerWidth;
      // if(screenWidth > 767){
      //   setChatHistoryHeight(141)
      // }else{
      //   setChatHistoryHeight(125)
      // }
      chatHistoryHeightFunc(true)
      // setCredits((credits) => credits - 1);
      setTimeout(() => {
        scrollToBottom()
      }, 100);
      
    } catch (error) {
      setErrorMessageState(() => true);
      setToastMessage({msg:error.message,severity:"error"});
      console.error("Error sending message:", error);
      setSendDisabled(()=>false)
    }

    
  };

  const fetchData = async (chatfilterNo) => {
    // setTemplateMessage(null);
              // setTemplateHtml(null);
              // setTemplateMediaName(null);
              setTemplateModel(false)
              // setSelectedTemplate(null)
              setTemplatePreview(null)
              if(!chatfilterNo){
                setIsLoading(true);
              }
              setChatLoading(true);
              setSessionTime(0,0,0);
    var lastWabaNo=''
    const { infra, institute_hash } = getInfra();
    const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
    const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
    const effectiveDialcode = (candidate && candidate.country_dialcode) ? candidate.country_dialcode : collegeDialcode;
    const region = effectiveDialcode == collegeDialcode ? "national" : "international";
    try {
      const isAuthenticated = await validateAuth();
      if (!isAuthenticated) {
        return alert("Please login to portal");
      }
      if (candidate && "echo_enabled" in candidate && candidate.echo_enabled === false) {
        setEchoEnabled(false);
        setChat([]);
        setChatLoading(false);
        setIsLoading(false);
        return false;
      }
      if(candidate && (candidate.waba_number == '' || candidate.waba_number == undefined)){
        setChat([])
        setChatLoading(false)
        setIsLoading(false)
        return false
      }
      const post_data = prepareAJAXData({
          room_id: `cr_${candidate.id}`,
          page: 0,
          whatsconfig_number: candidate?.waba_number,
          region: region,
          filter_whatsconfig_number:chatfilterNo?chatfilterNo:'',
          entity_id:userDetails?.EntityId,
          user_role:userDetails?.GroupId,
          user_id:userDetails?.UserId,
          entityType:userDetails.EntityType,
          masking:masking,
          url: `${meritto_service_url}/communication/v1/${collegeId}/chat-history`,
        }
      );
      const response = await axios.post(
        //`${constants.MS_SERVICE_URL}/communication/v1/${collegeId}/chat-history`,
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );

      if (response.data.data && "echo_enabled" in response.data.data && response.data.data.echo_enabled === false) {
        setEchoEnabled(false);
        setChat([]);
        setChatLoading(false);
        setIsLoading(false);
        return false;
      }
      setEchoEnabled(true);

      const newData = response.data.data?.listing;
      const session = response.data.data?.session;
      lastWabaNo=response.data.data?.last_waba_number
      setLastWabaNoSt(lastWabaNo)

      setChat([...newData].reverse());
      setSession(session);
      sendMessage(
        JSON.stringify({ type: "join_chat", room_id: `cr_${candidate.id}` })
      );
      setChatLoading(false);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
    if(!chatfilterNo){
    try {
      const post_data = prepareAJAXData(
      {
          room_id: `cr_${candidate.id}`,
          page: page + 1,
          whatsconfig_number: candidate?.waba_number,
          region: region,
          logged_user_id:userDetails?.UserId,
          logged_user_group:userDetails?.GroupId,
          url: `${meritto_service_url}/communication/v1/${collegeId}/live-chat-number-list`,
        }
      );

      const response = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      var config=Number(response.data.data?.show_default_number)
      setDefaultConfig(config);
      if (response && response.data && response.data.data  && response.data.data.echo_status ) {
        setEchoStatus(String(response.data.data.echo_status));
    } else{
      setEchoStatus('0');
    } 
      if (response && response.data && response.data.data  && response.data.data.business_numbers && response.data.data.business_numbers.length >0 ) {
        var business_numbers=response.data.data.business_numbers;
        setWabaNos(business_numbers);
        var wabaTemp={}
        var matchLastWabaNo=0;
        business_numbers.forEach(row => {
          if(row.live_chat_enable){
            setCheckAnyEnableNo(true);
            if(row.business_number == lastWabaNo && config && row.live_chat_enable){
              setSelectedWabaNo(lastWabaNo);
              matchLastWabaNo++;
            }
          }
          wabaTemp[row.business_number]=row.alias; 
        }
      );
      if(matchLastWabaNo == 0){
          setSelectedWabaNo(' ');
        }
      setWabaAliasConfig(wabaTemp)

    }  
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessageState(() => true);
      setToastMessage({msg:error.message,severity:"error"});
    }
    setIsLoading(false);

  }
  };  

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.customColor.tableHead
    }
  }));

  const typingHandler = (event) => {
    let typingTimeout;
    if (!typing) {
      setTyping(true);
      sendMessage(
        JSON.stringify({ type: "typing", room_id: `cr_${candidate.id}` })
      );
    }
    let lastTypingTime = new Date().getTime();
    var timerLength = 3000;

    typingTimeout = setTimeout(() => {
      var timeNow = new Date().getTime();
      var timeDiff = timeNow - lastTypingTime;
      if (timeDiff >= timerLength && typing) {
        sendMessage(
          JSON.stringify({ type: "stop typing", room_id: `cr_${candidate.id}` })
        );
        setTyping(false);
      }
    }, timerLength);
    return () => {
      clearTimeout(typingTimeout);
    };
  };
  React.useEffect(() => {
    if (candidate && "echo_enabled" in candidate && candidate.echo_enabled === false) {
      setEchoEnabled(false);
    } else {
      setEchoEnabled(true);
    }
    setConversationView('all')
    chatHistoryHeightFunc()
    fetchData();
    setEchoStatus('');
    getQueryParamsFromURL();
    setUploadModel(false);
    setUploadFields('');
    setUploadFileInfo('');
    setSelectedUploadField('');
    setBinaryDataForLm('');
    setFileUrl('');
    return () => {
      setPage((page) => 0);
      setHasMoreData((hasMoreData) => true);
    };
  }, [candidate]);

  const getQueryParamsFromURL = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams) {
      params[key] = value;
    }

    if(params && params.pos && params.pos == 2){
      setToggleMinIcon(true);
    }
    return params;
  };
  React.useEffect(()=>{
    const getTemplateList =async() =>{
      const { infra, institute_hash } = getInfra();
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
      try {
        const post_data = prepareAJAXData(
        {
            room_id: `cr_${candidate.id}`,
            logged_user_id:userDetails?.UserId,
            logged_user_group:userDetails?.GroupId,
            url: `${meritto_service_url}/communication/v1/${collegeId}/get-live-chat-template-list`,
          }
        );
  
        const response = await axios.post(
          `${meritto_node_url}/chat/${collegeHash}/getData`,
          post_data
        );
         if (response && response.data && response.data.data  && response.data.data.template_list && response.data.data.template_list.length >0 ) {
          setTemplateList(response.data.data.template_list);
      }
      } catch (error) {
        console.error("Error fetching data:", error);
        setErrorMessageState(() => true);
        setToastMessage({msg:error.message,severity:"error"});
      }
    }      
   if (templateModel && templateList.length == 0){
    setTemplateLoder(true)
    getTemplateList();
    setTemplateLoder(false)
   }
},[templateModel])
  React.useEffect(() => {
    if (lastMessage) {
      const message = JSON.parse(lastMessage.data);
      if(masking){
      if(message && message.whatsappMessage){
        var tempmsg=message.whatsappMessage
        var tempbody=tempmsg && tempmsg.body ? (tempmsg.body).split("rec_msg"):'';
        var realBody=tempmsg.body;
         if(tempbody && tempbody.length ==2){
           if(tempbody[0].includes("template-title")){
              var maskData=maskEmailsInString(tempbody[0])
              realBody=maskData+tempbody[1];
           }  
          }      
          message.whatsappMessage.body=realBody
      }else if(message && message.newMessage){
        var tempmsg=message.newMessage
        var tempbody=tempmsg && tempmsg.body ? (tempmsg.body).split("rec_msg"):'';
        var realBody=tempmsg.body;
         if(tempbody && tempbody.length ==2){
           if(tempbody[0].includes("template-title")){
              var maskData=maskEmailsInString(tempbody[0])
              realBody=maskData+tempbody[1];
           }  
          }      
          message.newMessage.body=realBody
      }
    }


      if (
        message.type === "typing" &&
        message.room_id === `cr_${candidate.id}`
      ) {
        setIsTyping(true);
      }
      if (
        message.type === "stop typing" &&
        message.room_id === `cr_${candidate.id}`
      ) {
        setIsTyping(false);
      }
      if (
        message.type === "message recieved" &&
        message.room_id === `cr_${candidate.id}`
      ) {
        setChat((prevChat) => [...prevChat, message.newMessage]);
        if(toggleMinIcon){
          setNewMsgBlink(true)
        }
      }
      if (
        message.type === "lead message" &&
        message.whatsappMessage.room_id !== `cr_${candidate.id}`
      ) {
        setLeadMessage(message.whatsappMessage);
        setFetchAgain(!fetchAgain);
      } else if (
        message.type === "lead message" &&
        message.whatsappMessage.room_id === `cr_${candidate.id}`
      ) {
        setChat((prevChat) => [...prevChat, message.whatsappMessage]);
        if(toggleMinIcon){
          setNewMsgBlink(true)
        }
      }
    }
  }, [lastMessage]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const isValidFileName = (fileName) => {
    const invalidCharsRegex = /[<>:"/\\|?*$#@%*()!~&{}'`+=]/; // Add other characters as needed
    return !invalidCharsRegex.test(fileName);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
  };
  const ITEM_HEIGHT = 48;
  const validateFileUpload =(file,type)=>{
    const ext = fileExtension(file.name)
    if(type === "document"){
      const allowedFormat = ['pdf','docx','pptx','xlsx','txt'];
      if (!allowedFormat.includes(ext)) {
        setErrorMessageState(() => true);
        setToastMessage({msg:'Only pdf,docx,pptx,xlsx,txt formats are allowed.',severity:"error"});
        return;
      }
      if(file.size > 5*1024*1024){
        setErrorMessageState(() => true);
        setToastMessage({msg:'File size is too large',severity:"error"});
        return false
      }
      if(file && file.name && file.name.length >100){
        setErrorMessageState(() => true);
        setToastMessage({msg:'File name is too large',severity:"error"});
        return;
      }
    }
    if(type ==="image"){
      const allowedFormat = ['jpg','jpeg','png']
      if (!allowedFormat.includes(ext)) {
        setErrorMessageState(() => true);
        setToastMessage({msg:'Only JPEG, PNG, and JPG formats are allowed.',severity:"error"});
        return;
      }
      if(file.size > 1*1024*1024){
        setErrorMessageState(() => true);
        setToastMessage({msg:'Image size is too large.',severity:"error"});
        return false
      }
      if(file && file.name && file.name.length >100){
        setErrorMessageState(() => true);
        setToastMessage({msg:'Image name is too large',severity:"error"});
        return;
    }
    }
    if(type==="video"){
      const allowedFormat = ['mp4']
      if (!allowedFormat.includes(ext)) {
        setErrorMessageState(() => true);
        setToastMessage({msg:'Only mp4 formats are allowed.',severity:"error"});
        return false;
      }
      if(file.size > 5*1024*1024){
        setErrorMessageState(() => true);
        setToastMessage({msg:'Video size is too large',severity:"error"});
        return false;
      }
      if(file && file.name && file.name.length >100){
        setErrorMessageState(() => true);
        setToastMessage({msg:'Video name is too large',severity:"error"});
        return;
    }
    }
    if (!isValidFileName(file.name)) {
      setErrorMessageState(() => true);
      setToastMessage({msg:"Invalid file name. Please avoid using special characters like <>:\"/\\|?*$#@%*()!~&{}'`+=",severity:"error"});
      return;
    } 
    return true
  }
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const fileValidation = validateFileUpload(file,"document")
    if(!fileValidation){
      return
    }
    setBinaryData(file);
    setEnterShow(true);
    setAnchorEl(null);
    setMessageType("document");
    inputRef.current.focus();
  };

  const handleImgChange = (event) => {
    const file = event.target.files[0];
    const fileValidation= validateFileUpload(file,"image")
    if(!fileValidation){
      return 
    }
    setBinaryData(file);
    setEnterShow(true);
    setAnchorEl(null);
    setMessageType("image");
    inputRef.current.focus();
  };

  const handleVidChange = (event) => {
    const file = event.target.files[0];
    const fileValidaton = validateFileUpload(file,"video")
    if(!fileValidaton){
      return
    }
    setBinaryData(file);
    setEnterShow(true);
    setAnchorEl(null);
    setMessageType("video");
    inputRef.current.focus();
  };

  function handleDocumentUpload() {
    triggerGtmAction('Document')
    if (fileInputRefDoc.current) {
      fileInputRefDoc.current.click();
    } else {
      setErrorMessageState(() => true);
      setToastMessage({msg:'Error while uploading file',severity:"error"});
    }
  }

  function handleImgUpload() {
    triggerGtmAction('Image')
    fileInputRefImg.current.click();
  }

   function  templateModelOpen (event){
    triggerGtmAction('Templates')
    setTemplateData(null);
    // setTemplateHtml(null);
    // setSelectedTemplate(null);
    setMessage('');
    setEnterShow(false);
      setTemplateModel(true);
      setAnchorEl(null);
              // setTemplateMessage(null);
              // setTemplateMediaName(null);
  }
//   async function selectTemplate(){
//      setMessage(templateData?.message);
//      if(templateData.message.length > 0){
//      setEnterShow(true);
//      }
//     setSelectedTemplate(templatePreview)
//    await setTemplateMediaName(templateData?.file_name)
//     setTemplateModel(false);
//     setTemplatePreview(null);
//     chatHistoryHeightFunc();
//  }
 

 function chatHistoryHeightFunc (resetInputHeight) {
  
  if(resetInputHeight) {
    var editorElem = 67
  }else {
    let editorElement = document.getElementById("editor-block");
    if (editorElement) {
        var editorElem = editorElement.offsetHeight;
    }
  }
  let headerElement = document.getElementById("chat-head");
    if (headerElement) {
        var headerElem = headerElement.offsetHeight;
    }
    setChatHistoryHeight(editorElem + headerElem );
 }

 const handleInputKeyup = () => {
    chatHistoryHeightFunc()
 }
 

 const handleKeyPressOnSearch = (event) => {
   if (event.key === "Enter") {
     event.preventDefault(); // Prevent default Enter behavior
   }
 };

 

 function handleSlash(event){
  const value =event.target.value;
  if (value.charAt(0).toLowerCase() === '/' && !templatePreview ) {
    templateModelOpen();
    if(templateModel ) {
      return value
    }else{
    return ''
    }
  }else{
    return value
  }
}

const handleCloseEchoIframe = () => {
  var iframeCloseData = {
    msg : "closeIframe",
    appId : `cr_${candidate.id}`
  };
  window.parent.postMessage(iframeCloseData, '*');
  var generateEncryptedID=encryptText(`cr_${candidate.id}`)
  var opendIframe=localStorage.getItem("eoi")
  if(opendIframe){
    let newIframeIds = [];
     newIframeIds=JSON.parse(opendIframe)
    if(newIframeIds.includes(generateEncryptedID)){
      const updatedIframeIds = newIframeIds.filter(item => item !== generateEncryptedID);
      localStorage.setItem("eoi", JSON.stringify(updatedIframeIds));
     }
  } 
 }

const handleMinimizeIframe = () => {
  setToggleMinIcon(!toggleMinIcon)
  setNewMsgBlink(false)
  var iframeMinMaxIframe = {
    msg : "minMaxframe",
    appId : `cr_${candidate.id}`
  };
  window.parent.postMessage(iframeMinMaxIframe, '*');
}


const filterTemplateList =(input)=>{
  var input, filter, ul, li, a, i, txtValue,txtEle;
    filter = input.toUpperCase();
    ul = document.getElementById("templates-List");
    li = ul.getElementsByClassName("list-item");
    var countHideItem=0;
    for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByClassName("template-title")[0];
        txtEle = a.getElementsByTagName("span")[0];        
        txtValue = txtEle.textContent || txtEle.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
        } else {
            li[i].style.display = "none";
            countHideItem++;
        }
        if(countHideItem == li.length){
          setSearchTemplateNoData(true)
        }else{
          setSearchTemplateNoData(false)
        }
    }
}

const handleSearchChange = (event) => {
  var input = event.target.value;
  setTemplateFilterValue(input);
  filterTemplateList(input);
 };

 const handleEnterTemplateSearch = (e) => {
  if(e.keyCode === 13 && !e.shiftKey){
    e.preventDefault();

  if(templateFilterValue){
  filterTemplateList(templateFilterValue);
  }
}
 };

 function fucosOnTemplateSearch(){
  let width = window.innerWidth;
  if(width < 767){
    document.getElementById('template-list-block').classList.add("selected");
  }
 }
 async function generatetemplatePreview(template){
  triggerGtmAction('Template Preview')
  let width = window.innerWidth;
  if(width < 767){
    document.getElementById('template-list-block').classList.remove("selected");
  }

  setTemplatePreview(template)
  if(template && template.id){
    try {
      const { infra, institute_hash } = getInfra();
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const post_data = prepareAJAXData(
      {
          tid:template.id,
          type: "preview",
          url: `${meritto_service_url}/communication/v1/${collegeId}/get-template-preview`,
        }
      );
      const response = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      if (response && response.data && response.data.data) { 
          // setTemplateHtml(response.data.data?.html);
          setTemplateData(response.data.data);
      } else {
        setHasMoreData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessageState(() => true);
      setToastMessage({msg:error.message,severity:"error"});
    } finally {
      console.log("set is loading false");
    }  
  }else{
    setErrorMessageState(() => true);
    setToastMessage({msg:'Have Some Technical issue in Template Preview',severity:"error"});
  }
 }
 function chatFilter(value){
  fetchData(value);
 }
 function sendtemplate(){
  triggerGtmAction('Temaplate Send')

  if(selectedWabaNo == ' ' || selectedWabaNo == '' || selectedWabaNo ==null){
    setErrorMessageState(() => true);
    setToastMessage({msg:'Please select WABA Number to send message from',severity:"error"});
     setSendDisabled(()=>false)
     return false
  }
   sendMessage1();

  //  setSelectedTemplate(null);
  setTemplateModel(false);
    setTemplatePreview(null);
 }
  function handleVidUpload() {
    triggerGtmAction('Video')
    fileInputRefVid.current.click();
  }
  const loadMoreData = async (__page) => {
    if (!echoEnabled || chatHistoryLoading || !hasMoreData) return;
    setChatHistoryLoading(true);
    try {
      const { infra, institute_hash } = getInfra();
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const effectiveDialcode = (candidate && candidate.country_dialcode) ? candidate.country_dialcode : collegeDialcode;
      const region = effectiveDialcode == collegeDialcode ? "national" : "international";
      const post_data = prepareAJAXData(
      {
          room_id: `cr_${candidate.id}`,
          page: page + 1,
          whatsconfig_number: candidate?.waba_number,
          region: region,
          filter_whatsconfig_number:conversationView && conversationView !='all'?conversationView:'',
          entity_id:userDetails?.EntityId,
          user_role:userDetails?.GroupId,
          user_id:userDetails?.UserId,
          entityType:userDetails.EntityType,
          masking:masking,
          url: `${meritto_service_url}/communication/v1/${collegeId}/chat-history`,
        }
      );
      const response = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      if (response.data.data.listing.length > 0) {
        const newData = response.data.data?.listing;
        setChat((prevData) => [...newData.reverse(), ...prevData]);
        setPage((page) => page + 1);
      } else {
        setHasMoreData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessageState(() => true);
      setToastMessage({msg:error.message,severity:"error"});
    } finally {
      console.log("set is loading false");
      setChatHistoryLoading(false);
    }
  };
  const scroll = () => {
    if (containerRef.current) {
      const container = containerRef.current;
      if(page < 2){
        // container.scrollTop = container.scrollHeight - container.scrollTop * page;
      container.scrollTop = container.scrollHeight;
      }    
    }

  };
  React.useEffect(() => {
    scroll();
  }, [chat]);
  const handleEnterPress = (event) => {
      if(event.keyCode === 13 && !event.shiftKey) {
        event.preventDefault();
        if(!sendDisabled && message){
          triggerGtmAction('Send')
             sendMessage1();
          }
      } 

      const inputElement = event.target;
    const isTextSelected = inputElement.selectionStart === 0 && inputElement.selectionEnd === inputElement.value.length;

    if ((event.key === 'Backspace' || event.key === 'Delete') && isTextSelected) {
      setTimeout(() => {
        chatHistoryHeightFunc(true)
      }, 300);
    }
  };
  const handleCut = () => {
    setTimeout(() => {
      chatHistoryHeightFunc(true)
    }, 300);
  }
  
  React.useEffect(() => {
    var cuntertime=session
    var hours=parseInt(cuntertime/3600)
    cuntertime=cuntertime%3600
    var minutes=parseInt(cuntertime/60)
    cuntertime=cuntertime%60
    var seconds=cuntertime
    setSessionTime({hours,minutes,seconds})

},[session]);
  React.useEffect(() => {
    if (transcript.length > 0) {
      setMessage(transcript);
      setEnterShow(true);
      chatHistoryHeightFunc()
    } else {
      setEnterShow(false);
    }
  }, [transcript]);

  const clickMic = () => {
    triggerGtmAction('Voice')
    SpeechRecognition.startListening();
  };
  const handleFormSubmit = (event) => {
    event.preventDefault();
    sendMessage1();
  };

  const handleBinaryDelete = () => {
    setBinaryData(null);
    setMessageType("text");
  };

  
  function convertSecondsToHoursMinutes(seconds) {
    if (isNaN(seconds)) {
      return "Invalid input";
    }

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    return `${hours}:${minutes}`;
  }

  function getWabaNoOptions(type  ,widget=false, seesionCheckCanned =false){
    var wabaMenu=[]
    if(seesionCheckCanned){
      wabaNos.forEach(row => {
      if(row.live_chat_enable && type && (row.session >0 || row.business_number == tempWabaNo && session>0 )  ){
        wabaMenu.push(<MenuItem value={row.business_number} name={row.session}>{row.alias} {(lastWabaNoSt==row.business_number && defaultConfig)?' (Default)':''}</MenuItem>)
      } 
    });}
    else{
      wabaNos.forEach(row => {
        if(row.live_chat_enable && widget ){
          wabaMenu.push(<MenuItem id={row.business_number} value={row.business_number} name={row.session} onClick={(e)=>{
            chatFilter(Number(e.target.id));
            setConversationView(e.target.id);
            triggerGtmAction('View');
            setWabaAnchorEl(null);
           }}>{row.alias} {(lastWabaNoSt==row.business_number && defaultConfig)?' (Default)':''}</MenuItem>)
        }else{

        if(row.live_chat_enable && type ){
          wabaMenu.push(<MenuItem value={row.business_number} name={row.session}>{row.alias} {(lastWabaNoSt==row.business_number && defaultConfig)?' (Default)':''}</MenuItem>)
        }else if(row.view_conversations && !type){
          wabaMenu.push(<MenuItem value={row.business_number}>{row.alias}</MenuItem> )
        }
      }
        
      });
    }
     
    return wabaMenu
  }
  async function  changeEchoStatus(status,updateMsg){
    setStatusChangeLoading(true)
    try {
      const { infra, institute_hash } = getInfra();
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const effectiveDialcode = (candidate && candidate.country_dialcode) ? candidate.country_dialcode : collegeDialcode;
      const region = effectiveDialcode == collegeDialcode ? "national" : "international";
      const post_data = prepareAJAXData(
      {
        applicant_id:candidate.id,
          echo_status: Number(status),
          waba_number: lastWabaNoSt ,
          sender_id: String(userDetails?.UserId),
          receiver_dial_code: effectiveDialcode,
          name:candidate.name,
          mobile:candidate.mobile_no,
          region: region,
          url: `${meritto_service_url}/communication/v1/${collegeId}/update-echo-status`,
        }
      );
      const responseUpdate = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
     
      if (responseUpdate.data.data.updated) {
        if(updateMsg == 'intervened'){
          setTempSession(responseUpdate.data.data.session_expire_time) 
          setSession(responseUpdate.data.data.session_expire_time )
          setTempWabaNo(lastWabaNoSt)
          }
        else{
          setTempSession(null)
          setSession(null)
          setTempWabaNo(null)
        }
        const post_data = prepareAJAXData({
          room_id: `cr_${candidate.id}`,
          sender_id: String(userDetails?.UserId),
          message: userDetails?.Name ,
          message_type:updateMsg,
          job_id: chat.length
            ? String(chat.slice(-1)[0].communication_log_id)
            : "0", ///last message job id
          whatsconfig_number: lastWabaNoSt ,
          url: `${meritto_service_url}/communication/v1/${collegeId}/send-echo-status-message`,
        })
  
        const response = await axios.post(
          `${meritto_node_url}/chat/${collegeHash}/getData`,
          post_data
        );
        if (response.data.data.error) {
          throw new Error(response.data.data.error);
        }
        const chatData = response.data.data?.chat_data;
      const newMessage1 = {
        room_id: chatData?.room_id,
        communication_log_id: chatData?.communication_log_id,
        body: chatData.body,
        created_at: chatData.created_at,
        from: chatData.from,
        name: chatData.name,
        sender_id: chatData.sender_id,
        sender_type: chatData.sender_type,
        // status: chatData.status,
        sender_name: userDetails?.Name,
        type: chatData.type,
        url: chatData.url,
        whatsconfig_number: selectedWabaNo,
        waba_number: selectedWabaNo,
      };
 
      sendMessage(
        JSON.stringify({
          type: "new message",
          newMessage: newMessage1,
          room_id: `cr_${candidate.id}`,
        })
      );
      setChat((prevChat) => [...prevChat, newMessage1]);
        setEchoStatus(status);
        setTabVal(status=='4'?'0':status);         
        }else{
        setErrorMessageState(() => true);
        setToastMessage({msg:responseUpdate.data.message,severity:"error"});
       }  
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessageState(() => true);
      setToastMessage({msg:error.message,severity:"error"});
    } finally {
      console.log("set is loading false");
      // setChatHistoryLoading(false);
    }

    setStatusChangeLoading(false)
    
  }
  function getTemplateList(){
    var tempList =[]
    templateList.forEach(row => {
      if(session){
        tempList.push(
      <ListItem className={row.id==(templatePreview?templatePreview.id:'')?"active list-item":'list-item'} sx={{"&:hover": {
          backgroundColor: theme.palette.action.hover, // Hover background
          color: theme.palette.text.secondary, // Hover text color
        } }} onClick={()=>{generatetemplatePreview(row)}}>
          <ListItemText className="template-title" primary={row.template_title}  />
          <Typography className="template_category">{row.template_category}</Typography>
      </ListItem>
        );
      }else{
        if(row.template_nature != 'canned' ){
          tempList.push(
          <ListItem className={row.id==(templatePreview?templatePreview.id:'')?"active list-item":'list-item'} sx={{"&:hover:not(.active)": {
            backgroundColor: theme.palette.action.hover, // Hover background
            color: theme.palette.text.secondary, // Hover text color
          }, backgroundColor: row.id==(templatePreview?templatePreview.id:'')&&theme.palette.customColor.cardActive  }}  onClick={()=>{generatetemplatePreview(row)}} >
          <ListItemText className="template-title" primary={row.template_title}  />
          <Typography className="template_category">{row.template_category}</Typography>
      </ListItem>)
        }
      }
    });
    return tempList;
  }
  function generateProfileUrl(){
    let { infra, institute_hash } = getInfra();
    if(!institute_hash){
      institute_hash=instituteHash
    }
    const meritto_npf_url = getBaseUrl("NPF_BACKEND", infra,"",institute_hash);
    if(candidate && candidate.profile_token){
    var url =meritto_npf_url+"/counsellors/user-profile/"+candidate.profile_token
    return url
    } 
    return null;
  }
  function showChatDate(msgTimestamp,index){

   var  msgCurrentdateObj = new Date(msgTimestamp * 1000)
    
   var   msgCurrentdate=`${monthsName[(msgCurrentdateObj.getMonth() + 1)]} ${msgCurrentdateObj.getDate().toString().padStart(2, '0')}, ${msgCurrentdateObj.getFullYear()}`
    var  msgDateTime='';
    if(index > 0 && msgCurrentdate != ''){
        //add switch case
        if(currentDate == msgCurrentdate && displayDateFlag != msgCurrentdate){
          msgDateTime='Today'
          displayDateFlag=msgCurrentdate
        }else if(yesterdayDate == msgCurrentdate && displayDateFlag != msgCurrentdate){
          msgDateTime='Yesterday'
          displayDateFlag=msgCurrentdate
        }else if(displayDateFlag != msgCurrentdate){
          msgDateTime=msgCurrentdate
          displayDateFlag = msgCurrentdate
        }
    }else{
      var  currentdateObj = new Date();
      var  yesterdaydateObj = new Date();
      yesterdaydateObj.setTime(yesterdaydateObj.getTime()- (24 * 60 * 60 * 1000));
      var   currentdateTemp=`${monthsName[(currentdateObj.getMonth() + 1)]} ${currentdateObj.getDate().toString().padStart(2, '0')}, ${currentdateObj.getFullYear()}`
      var yesterdayDateTemp=`${monthsName[(yesterdaydateObj.getMonth() + 1)]} ${yesterdaydateObj.getDate().toString().padStart(2, '0')}, ${yesterdaydateObj.getFullYear()}`
      currentDate=currentdateTemp;
      yesterdayDate=yesterdayDateTemp;
      if(currentDate == msgCurrentdate && displayDateFlag != msgCurrentdate){
        msgDateTime='Today'
        displayDateFlag=msgCurrentdate
      }else if(yesterdayDate == msgCurrentdate && displayDateFlag != msgCurrentdate){
        msgDateTime='Yesterday'
        displayDateFlag=msgCurrentdate
      }else if(displayDateFlag != msgCurrentdate){
        msgDateTime=msgCurrentdate
        displayDateFlag = msgCurrentdate
      }
    }
   if(msgDateTime){
    zindexOfDate=zindexOfDate+1    
   return (
    <Box
    component={'div'}
    sx={{ zIndex: zindexOfDate, position: 'sticky', top: '10px', textAlign:'center', mt: 1 }}
  >
     
       <Typography
         component="span"
         className="time-sticky"
         dangerouslySetInnerHTML={{ __html :  msgDateTime} }
         sx={{fontSize: '1rem', bgcolor: theme.palette.customColor.timeBg, color: '#fff'}}
       >
       </Typography>
  </Box>
      )
  }
}
function showMsgSendorName(waba_number,sender_type,sender_name,msgTimestamp,body){
  var  msgCurrentdateObj = new Date(msgTimestamp * 1000)
  var   msgCurrentdate=`${monthsName[(msgCurrentdateObj.getMonth() + 1)]} ${msgCurrentdateObj.getDate().toString().padStart(2, '0')}, ${msgCurrentdateObj.getFullYear()}`
  var groupMsgSideCheck=''
  if(sender_type == 'user' || sender_type == 'system' || sender_type == 'niaa'){
    groupMsgSideCheck= 'right'
  }else{
    groupMsgSideCheck= 'left'
  }
    if((groupMsgSideCheck != groupMsgSide || groupMsgWabaNo != waba_number) || preMsgDate != msgCurrentdate || lastsendertype != sender_type || sender_name != lastSendor){
      groupMsgSide=groupMsgSideCheck
    groupMsgWabaNo=waba_number
    preMsgDate=msgCurrentdate
    lastsendertype=sender_type
    lastSendor = sender_name
    return(
      <>
        <Typography component={'div'} sx={{mt: 2, color: theme.palette.customColor.textDark}} className="sender-name">
          {sender_type == 'niaa'?<img src={niaaImg} alt="niaa" />:
          <img src={whatsAppImg} alt="whatsapp" />}
          {/* <img src={niaaImg} alt="whatsapp" /> */}
          {wabaAliasConfig[waba_number]}
        {sender_type === "user" ||
          sender_type === "system" ?  <span className="name">{'(' +sender_name + ')'}</span> : null }</Typography> 
      </>
    )
  }
}

  function generateProfileUrl(){
    let { infra, institute_hash } = getInfra();
    if(!institute_hash){
      institute_hash=instituteHash
    }
    const meritto_npf_url = getBaseUrl("NPF", infra,"",institute_hash);
    if(candidate && candidate.profile_token){
      let targetCollegeId = collegeId;
      if (candidate.college_id) {
        targetCollegeId = candidate.college_id;
      }
      const collegeHashValue = makeInstituteHash(targetCollegeId)
    var url =meritto_npf_url+"/counsellors/user-profile/"+candidate.profile_token+"?hash="+collegeHashValue
    return url
    } 
    return null;
  }

  function getDocName(url){
    let fileName =url? url.split('/').pop():'';
    return fileName
  }
  
  const WABA_ITEM_HEIGHT = 48;

  const [wabaAnchorEl, setWabaAnchorEl] = React.useState(null);
  const wabaOpen = Boolean(wabaAnchorEl);
  const handleWabaNumberClick = (event) => {
    setWabaAnchorEl(event.currentTarget);
  };
  const handleWabaNumberClose = () => {
    setWabaAnchorEl(null);
  };

  function appEventHandle(applicant_id) {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("android")) {
        console.log("Loaded in an iframe from Android device.");
        if (window.AndroidHandler && window.AndroidHandler.viewProfile) {
            window.AndroidHandler.viewProfile(applicant_id);
        } else {
            console.error("AndroidHandler is not defined");
        }
    } else if (userAgent.includes("iphone") || userAgent.includes("ipad") || userAgent.includes("ipod") || userAgent.includes("ios")) {
        console.log("Loaded in an iframe from iOS device.");
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.handler) {
            window.webkit.messageHandlers.handler.postMessage({
                'leadId': applicant_id
            });
        } else {
            console.error("iOS handler is not defined");
        }
    } else {
        console.log("Loaded in an iframe from another device.");
    }
}

  const handleLmFileChange = (event) => {
    setUploadLoader(false)
    const file = event.target.files[0];
    if(file){
    setBinaryDataForLm(file);
    processUploadFile(false, false, file);
    setAnchorEl(null);
    }
  };
 
 function handleDocumentUploadToLm() {
    if (fileInputRefAttachment.current) {
      fileInputRefAttachment.current.click();
    } else {
      setErrorMessageState(() => true);
      setToastMessage({msg:'Error while uploading file',severity:"error"});
    }
  }
 async function processUploadFile(file_id = false,url=false,file=false){
    try { 
      const { infra, institute_hash } = getInfra();
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const post_data = prepareAJAXData({
        user_id: candidate.id,
        file_id: Number(file_id) ,
        url: `${meritto_service_url}/communication/v1/${collegeId}/get-file-upload-info`,
      })

      const response = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      if(response && response.data && response.data.status && response.data.data){
        let resData = response.data.data
        setUploadFields(resData?.upload_info)
        setUploadModel(true);
        setFieldSearch('');
        if(file_id){
        let file_info =resData?.file_info;
        let fileType = file_info && file_info.type && file_info.type.includes("/") ? file_info.type.split("/")[1] : file_info.type;
        file_info['s_type'] = fileType
        setUploadFileInfo(file_info);
        }else{
          const file_info = {
            name: file.name,
            size: file.size,
            type: file.type,
            s_type: fileExtension(file.name)
          }
          setUploadFileInfo(file_info)
        }
        setFileUrl(url)
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  }
  async function uploadFileToLm(){
    setUploadLoader(true);
    try {
      if(selectedUploadField){
      const { infra, institute_hash } = getInfra();
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const file_details = {
        [selectedUploadField]:[uploadFileInfo.name, uploadFileInfo.size, uploadFileInfo.type, uploadFileInfo.s_type]
      }
      const active_tab = uploadFields[selectedUploadField] && uploadFields[selectedUploadField].active_tab ? uploadFields[selectedUploadField].active_tab:null;
      const field_title = uploadFields[selectedUploadField] && uploadFields[selectedUploadField].title ? uploadFields[selectedUploadField].title:null;

      const formData = new FormData();
      if(binaryDataForLm){
      formData.append("file", binaryDataForLm);
      }
      let preData=prepareAJAXData({  
        applicant_id: candidate.id,
        file_url: fileUrl ? fileUrl : '',
        user_id: userDetails.EntityId,
        active_tab:active_tab,
        file_detail:file_details,
        field_title:field_title,
        user_role:userDetails.RoleName,
        user_name:userDetails.Name,
        upload_field:[selectedUploadField]+'_0',
        url:`${meritto_service_url}/communication/v1/${collegeId}/upload-echo-file-to-lead`})
      formData.append(
        "incData",
        preData.data
      );
      const post_data = formData;
      const response = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/uploadDataToLm`,
        post_data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if(response && response.data.status == 200 ){
        setUploadLoader(false)
          if(response.data && response.data.message){
            if(echoStatus && (echoStatus== echoTabName.Niaa || echoStatus == echoTabName.Queued || echoStatus ==  echoTabName.Resolve || echoStatus == echoTabName.AutoResolve)){
              changeEchoStatus(echoTabName.Picked ,'intervened')
            }
            setToastMessage({msg:response.data.message,severity:"success"});
            if(fileInputRefAttachment.current && fileInputRefAttachment.current.value){
            fileInputRefAttachment.current.value= '';
            }else{
              fileInputRefAttachment.current= '';
            }
          }else{
            setToastMessage({msg:'Failed to upload',severity:"error"});
            if(fileInputRefAttachment.current && fileInputRefAttachment.current.value){
            fileInputRefAttachment.current.value= '';
            }else{
              fileInputRefAttachment.current= '';
            }
          }  
          setErrorMessageState(true);
          setUploadFields('')
          setUploadModel('');
          setUploadFileInfo('');
          setSelectedUploadField('');
          setFileUrl('');
          setBinaryDataForLm('');
      }else{
        let errorMsg=(response?.data?.message[selectedUploadField])? response?.data?.message[selectedUploadField]:'Failed to upload'; 
        setToastMessage({msg:errorMsg,severity:"error"});
        if(fileInputRefAttachment.current && fileInputRefAttachment.current.value){
        fileInputRefAttachment.current.value= '';
        }else{
          fileInputRefAttachment.current= '';
        }
        setErrorMessageState(true);
        setUploadFields('')
        setUploadModel('');
        setUploadFileInfo('');
        setSelectedUploadField('');
        setFileUrl('');
        setBinaryDataForLm('');
      }
     
    }else{
      <ToastAlert msg={"file_id not found"} severity={'error'} variant="filled" />
    }
    } catch (error) {
      <ToastAlert msg={error} severity={'error'} variant="filled" />
      console.error("Error uploading file:", error);
      throw error;
    }
  }
  function showUploadFields(){
      const validateField = (value) => {
        if( value.file_uploaded >= value.max_files || uploadFileInfo.size > value.max_file_size *1024*1024 || !value.upload_format.includes(uploadFileInfo.s_type)){
          return true
        }else{
        return false;
        }
      };
      const FieldDataEntries = Object.entries(uploadFields);
      const filteredData = FieldDataEntries.filter(([key, value]) =>
        key.toLowerCase().includes(fieldSearch.toLowerCase()) || (value.field_label && value.field_label.toLowerCase().includes(fieldSearch.toLowerCase()))
      ).sort((a,b)=>{
        let value= b[1]?b[1]:[]
        if(value && validateField(value)){
          return -1;
        }else{
          return 1;
        }
      });
      const handleCheckboxChange = (key) => {
        if( selectedUploadField == key){
        setSelectedUploadField(''); 
        }else{
          setSelectedUploadField(key); 
        }
      };
      
      return (
        <Box component={'div'}>
      

          <Paper
               component="form"
               sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', mb: 3 }}
            >
              <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
            <SearchIcon />
              </IconButton>
            <InputBase
               sx={{ width: '100%' }}
               type="text"
               placeholder="Search by name"
              inputProps={{ 'aria-label': 'Search by name' }}
              value={fieldSearch}
              onChange={(e) => setFieldSearch(e.target.value)}
              onKeyDown={handleKeyPressOnSearch}
               />
              </Paper>

<TableContainer component={Paper} className="attachment-container mobile-table">
      <Table stickyHeader aria-label="Attachment Table" >
      {filteredData.length !== 0 &&
        <TableHead>
          <TableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell>Name</StyledTableCell>
            <StyledTableCell sx={{width: '300px'}}>Format</StyledTableCell>
            <StyledTableCell>Size <Typography component={'span'} sx={{color: '#5e5e5e', fontSize: '1rem'}}>(MB)</Typography></StyledTableCell>
            <StyledTableCell>Upload Limit</StyledTableCell>
            
          </TableRow>
        </TableHead>
        }
        <TableBody>
        {filteredData.length === 0 ? <TableRow ><TableCell colSpan={5} sx={{py: 8}}><NoDataFound text="No Field Found" /></TableCell></TableRow> : (filteredData.map(([key, value]) => (
            <TableRow className={validateField(value)&&"row-disable"} key={key} hover
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell>
              <Tooltip title={validateField(value) ? "Attachment Disabled" : ""} arrow>
               <Box component={'span'}> 
              <Radio
                color="primary"
                className="check-row"
                checked={selectedUploadField === key}
                onChange={() => handleCheckboxChange(key)}
                disabled ={validateField(value)?true:false}
                inputProps={{
                  'aria-label': 'select all desserts',
                }}
              />
              </Box>
              </Tooltip>
              </TableCell>
               <TableCell data-title="Name">
                {value.field_label}
              </TableCell>
              <TableCell data-title="Format">{value.upload_format.join(", ")}</TableCell>
              <TableCell data-title="Size">{value.max_file_size}</TableCell>
              <TableCell data-title="Upload Limit">{value.file_uploaded}/{value.max_files}</TableCell>
              
              </TableRow>
          )))}
        </TableBody>
      </Table>
    </TableContainer>
    </Box>
      )
  }
  const handleDownload = async (url) => {
    const { infra, institute_hash } = getInfra();
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      try {
        const apiUrl = `${meritto_node_url}/chat/${collegeHash}/download-attachment?url=${encodeURIComponent(url)}`;
        const anchor = document.createElement('a');
        anchor.href = apiUrl;
        anchor.style.display = 'none';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      } catch (error) {
        console.error("Error download attachment:", error);
      }
 
};

const formatFileSize = (bytes) => {
  if (bytes < 1024) {
    return `${bytes} B`; // Bytes
  } else if (bytes < 1024 * 1024) {
    return `${Math.floor(bytes / 1024)} KB`; // Kilobytes (integer only)
  } else if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`; // Megabytes (1 decimal)
  } else {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`; // Gigabytes (1 decimal)
  }
};


const getAttachmentIconVar = (url) => {
  const fileExtention = fileExtension(getDocName(url));
  switch (fileExtention) {
   case 'pdf':
     return pdfImg;
   case 'doc':
     return docImg;
   case 'xlsx':
     return xlsxImg;
     case 'xls':
      return xlsImg;
   case 'docx':
      return docxImg;
   case 'pptx':
      return pptxImg;
   case 'txt':
      return txtImg;
    case 'csv':
        return csvImg;
    case 'jpg':
          return jpgImg;
    case 'jpeg':
          return jpegImg;
          case 'flv':
          return flvImg;
          case 'odt':
          return odtImg;
          case 'png':
          return pngImg;
          case 'mkv':
          return mkvImg;
          case 'm1v':
          return m1vImg;
          case 'm2v':
          return m2vImg;
          case 'mp4':
          return mp4Img;
          case 'mpeg':
          return mpegImg;
          case 'avi':
          return aviImg;
          case 'mov':
          return movImg;
          case 'divx':
          return divxImg;
          case 'm4v':
          return m4vImg;
          case '3gp':
          return gpImg;
          case 'zip':
          return zipImg;
          case 'gif':
          return gifImg;
   default:
     return defaultImg;
 }
 }

  const handleLeadIdCopySuccess = () => {
    setToastMessage({ msg: "Lead ID copied", severity: "success" });
    setErrorMessageState(true);
  };

  const handleLeadIdCopyError = () => {
    setToastMessage({ msg: "Unable to copy Lead ID", severity: "error" });
    setErrorMessageState(true);
  };

  const renderCandidateStatusRow = () => {
    const leadIdForCopy = getLeadIdForCopy(candidate);
    return (
    <Typography
      component="div"
      variant="div"
      sx={{ fontWeight: "500", fontSize: "1.2rem", mt: "-2px" }}
      className="candidate-status-row"
    >
      {echoStatusLabel[echoStatus] ? (
        <Typography
          component="div"
          variant="div"
          className={`${echoStatusLabel[echoStatus]} chatStatus`}
        >
          <FiberManualRecordIcon className="icon" />
          <Typography component="span" variant="span" className="status-text">
            {echoStatusLabel[echoStatus]}
          </Typography>
        </Typography>
      ) : null}
      {leadIdForCopy ? (
        <LeadIdCopyButton
          leadId={leadIdForCopy}
          onCopySuccess={handleLeadIdCopySuccess}
          onCopyError={handleLeadIdCopyError}
          styl = {{
            "bg":  theme.palette.copyBtn.copyBg,
            "text":  theme.palette.copyBtn.copyText
          }}

        />
      ) : null}
    </Typography>
    );
  };
  return (
    <>
      {errorMessageState && <Toast msg={toastMessage.msg} severity={toastMessage.severity}/>}
      <>{callBy == callByItems.widgetLead || callBy == callByItems.widgetLeadProfile?<Box
       color="secondary"
       className={'header-chat-inn widget'}
       id="chat-head"
       >  
        <Toolbar sx={{ p: '0 !important'}}>
       
            <NameLetter
              sx={{ mr: 1 }}
              nameLetter={Array.from(candidate && candidate.name ? candidate.name:'')[0]}
              nameType="icon"
            />
            {newMsgBlink?
             <Badge color="error" sx={{right: '12px', top:'-12px', width: '0px', height: '0px'}} className="blinkBadge errorBadge" overlap="circular" variant="dot" >
            </Badge>:null}

            <Typography sx={{ fontSize: "1.8rem", textTransform:'capitalize' }} className="candidate-nameBlk" noWrap component="div">
            {callBy == callByItems.mobile ?<Link href={'javascript:void(0)'} underline="none" color="primary" onClick={()=>{appEventHandle(candidate.id)}}>{candidate.name}</Link>:<>
            {callBy == callByItems.widgetLeadProfile?candidate.name:<Link href={generateProfileUrl()} target="_blank" underline="none" sx={{color: '#444'}}>{candidate.name}</Link>}
            {callBy == callByItems.widgetLead || callBy == callByItems.widgetLeadProfile ?null:<Typography sx={{fontSize: '1.2rem', ml: '.25rem'}} variant="span" component={"span"}>{" ("+candidate.mobile_no+")" }</Typography>}
            </>
            }
           {renderCandidateStatusRow()}
            </Typography>
          </Toolbar>
          <Stack direction="row" spacing={0} alignItems={'center'}>
            {!toggleMinIcon ? 
           <>
           {echoStatus && echoStatus== echoTabName.Picked?
          <Tooltip title="Resolved">
            <IconButton type="button">
              <DoneAllIcon onClick={()=>{changeEchoStatus(echoTabName.Resolve , 'resolved');triggerGtmAction('Resolve')}} />
            </IconButton>
            </Tooltip>:null}

            {echoEnabled ?
            <Tooltip 
            title="View Conversation"
            
            >
            <IconButton 
            type="button"
            aria-label="View Conversation"
            id="viewConversation"
            aria-controls={wabaOpen ? 'wabaNumberList' : undefined}
            aria-expanded={wabaOpen ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleWabaNumberClick}
            >
              <FilterListIcon />
            </IconButton>
            </Tooltip>
            : null}
            </>
            : null }

            {echoEnabled ?
            <Menu
        id="wabaNumberList"
        MenuListProps={{
          'aria-labelledby': 'viewConversation',
        }}
        anchorEl={wabaAnchorEl}
        open={wabaOpen}
        onClose={handleWabaNumberClose}
        className="filter-menu"
        PaperProps={{
          style: {
            maxHeight: WABA_ITEM_HEIGHT * 4.5,
          },
        }}
      >
         {getWabaNoOptions(false,true)}
      </Menu>
            : null}
            {callBy != callByItems.widgetLeadProfile?
            <Tooltip title={toggleMinIcon ? "Maximize" : "Minimize"}>
            <IconButton type="button" onClick={handleMinimizeIframe} size="small">
             {toggleMinIcon ? <KeyboardArrowUpIcon fontSize="large" /> : <KeyboardArrowDownIcon fontSize="large" />} 
            </IconButton>
            </Tooltip>:null}

            
            <Tooltip title="Close">
            <IconButton type="button" onClick={handleCloseEchoIframe}>
              <CloseIcon />
            </IconButton>
            </Tooltip>
          </Stack>
      </Box>:
       <Box
          color="secondary"
          position={` ${callBy == callByItems.widgetLead || callBy == callByItems.widgetLeadProfile ?'':'absolute'}`}
          className={`header-chat-inn ${attachmentModal == true ? 'modalActive' : ''}`}
          id="chat-head"
        >
          <Toolbar sx={{ p: '0 !important'}}>
            <NameLetter
              sx={{ mr: 1 }}
              nameLetter={Array.from(candidate && candidate.name ? candidate.name:'')[0]}
              nameType="icon"
            />
            <Typography sx={{ fontSize: "1.8rem", textTransform:'capitalize' }} className="candidate-nameBlk" noWrap component="div">
            {callBy == callByItems.mobile ?<Link href={'javascript:void(0)'} underline="none" color="primary" onClick={()=>{appEventHandle(candidate.id)}}>{candidate.name}</Link>:<>
            <Link href={generateProfileUrl()} target="_blank" underline="none" color="primary">{candidate.name}</Link>
            {callBy == callByItems.widgetLead || callBy == callByItems.widgetLeadProfile ?null:<Typography sx={{fontSize: '1.2rem', ml: '.25rem'}} variant="span" component={"span"}>{" ("+candidate.mobile_no+")" }</Typography>}
            </>
            }
            {renderCandidateStatusRow()}
            </Typography>
          </Toolbar>
          {echoStatus && echoStatus== echoTabName.Picked?
          <Typography className="header-timer">  
            { (sessionTime.hours >0 || sessionTime.minutes >0 || sessionTime.seconds > 0) && callBy == callByItems.livechat ?
            <>
            <Typography>  
            <Typography component={'span'} sx={{color: "#919191"}}>Session Left</Typography>
            <SessionTimer hours={sessionTime.hours} minutes={sessionTime.minutes} seconds={sessionTime.seconds} /> </Typography> </> :null
            }
          </Typography>:null}
          <Stack direction="row" spacing={3} alignItems={'center'}>
           
           { echoStatus && echoStatus== echoTabName.Picked?
              <div>
             <Button variant="contained" sx={{textTransform: 'capitalize'}} onClick = {()=>{changeEchoStatus(echoTabName.Resolve , 'resolved');triggerGtmAction('Resolve')}} disabled={statusChangeLoading}>{echoStatusButton[echoStatus]}</Button></div>:null}
          {echoEnabled && wabaNos.length>0?
          <FormControl sx={{display: `${templateModel ? "none" : ""}`, marginLeft: '5px !important', marginRight: '8px !important', width: '100px'}} size="small" className="selectBox head viewCon">
             <InputLabel id="demo-simple-select-label"><Typography component={'span'} variant="span" className="label">View</Typography> Conversation</InputLabel>
          <Select
                 labelId="demo-simple-select-label"
                 id="demo-simple-select"
                 placeholder="Select Whatapp No."
                 label="View Conversation"
                 onChange={(e)=>{
                  chatFilter(e.target.value);
                  setConversationView(e.target.value);
                  triggerGtmAction('View')
                 }}
                 value={conversationView}
                 disabled={templateModel}
              >
             
                <MenuItem value="all">All</MenuItem>
                {getWabaNoOptions(false,false)}
               
              </Select>
            </FormControl>
            :null}
            </Stack>
        </Box>}
        </>
       <Box
       sx={{ flexGrow: 1, p: 2, backgroundColor: theme.palette.background.default}}
        // sx={{ flexGrow: 1, p: mobileMatches ? 2 : 3 }}
        className={"chat-history-blk"}
        id="chat-history"
        ref={containerRef}
        style={{ height: callBy == callByItems.widgetLead || callBy == callByItems.widgetLeadProfile?( callBy == callByItems.widgetLeadProfile?`calc(100vh - 40px - ${chatHistoryHeight}px)`:`calc(100vh - 32px - ${chatHistoryHeight}px)`) : `calc(100vh - ${chatHistoryHeight}px)`  }}
      >
        {!echoEnabled ? (
          <EchoNotConfigured />
        ) : chatLoading ? (
          <>
            <Grid
              className="chat-grid"
              display={"flex"}
              justifyContent={"flex-start"}
            >
              <Box>               
                <Paper sx={{ p: 1, boxShadow:'rgba(11, 20, 26, 0.13) 0px 1px 0.5px' }}>
                  <Skeleton variant="text" width={100} />
                  <Skeleton variant="text" width={300} height={40} />
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Skeleton variant="text" width={60}  />
                </Box>
                </Paper>
                
              </Box>
            </Grid>

            <Grid
              className="chat-grid"
              display={"flex"}
              justifyContent={"flex-end"}
            >
              <Box>
                <Paper sx={{ p: 1, boxShadow:'rgba(11, 20, 26, 0.13) 0px 1px 0.5px' }}>
                <Skeleton variant="text" width={100}/>
                <Skeleton variant="text" width={300} height={40} />
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Skeleton variant="text" width={60}  />
                </Box>
                </Paper>
                
              </Box>
            </Grid>
          </>
        ) : (
          chat.length > 0 && (candidate && candidate.waba_number ) ? (
            <InfiniteScroll
              // style={{ margin: "10px" }}
              pageStart={page + 1}
              loadMore={loadMoreData}
              hasMore={hasMoreData}
              loader={
                chatHistoryLoading ? (
                  <Paper
                    className="chatHistory-loader"
                    sx={{ color: "#727272", zIndex: 9 }}
                    key={0}
                  >
                    Loading ...
                  </Paper>
                ) : null
              }
              isReverse={true}
              useWindow={false}
              initialLoad={false}
            >
              {chat.map((message, index) => (
                <>
                {showChatDate(message.created_at,index)}
                <Grid
                ref={messagesEndRef}
                  className={`chat-grid ${message.type == 'resolved' || message.type == 'intervened'?'cg-center': message.sender_type === "user" ||  message.sender_type === "system" || message.sender_type === "niaa"
                    ? "cg-right"
                    : "cg-left"}`}
                  key={index}
                  display={"flex"}
                >
                 
                  <Grid
                    display={"inline-flex"}
                    flexDirection={"column"}
                    item
                    xs={12}
                    sx={{
                      maxWidth:message.type == 'resolved' || message.type == 'intervened'? "100%":"80%",
                      minWidth: "180px",
                    }}
                  >
                     {/* {wabaAliasConfig[message.waba_number] && (
                        <Typography component={'div'} className="sender-name alias">
                          <img src={whatsAppImg} alt="whatsapp" />
                          {wabaAliasConfig[message.waba_number]}</Typography>
                      )} */}
                      {message.type == 'resolved' || message.type == 'intervened' ? <Item
                    className="item-blk actionMsgTag"
                    sx={{ 
                      boxShadow: 'none',
                      my: 4
                    }}
                    >
                      {(message.type == 'resolved' || message.type == 'intervened') && (
                        <Typography
                          component="div"
                          sx={{ 
                            boxShadow: '0 1px 0.5px rgba(11,20,26,.13)',
                            backgroundColor: theme.palette.customColor.editorBG
                          }}
                          className= { message.type == 'resolved' ?'title resolved':'title intervened'}
                          dangerouslySetInnerHTML={{ __html :  (message.type == 'intervened'? '<span class="status">Intervened by</span>': '<span class="status">Resolved by</span> ') +' <span class="hightlight ">'+ message.body+'</span'} }
                        >
                        </Typography>
                      )}
                      <Typography
                        sx={{
                          fontSize: ".9rem",
                          display: "flex",
                          justifyContent: 'center',
                          marginTop: '5px',
                          color: theme.palette.customColor.textDark
                        }}
                        className="timeStamp"
                        component="div"
                      >
                        <TimestampConverter
                          time={message.created_at}
                          callFrom="chatHistory"
                        />
                      </Typography> 
                      </Item>:
                      <>
                    {showMsgSendorName(message.waba_number,message.sender_type,message.sender_name,message.created_at, message.body)}
                    <Item
                    className={`item-blk ${parseInt(appTheme) == 3 ?'dark-theme':''}`}
                      sx={{
                        bgcolor:
                          message.sender_type === "user" ||
                          message.sender_type === "niaa" ||
                          message.sender_type === "system"
                            ? theme.palette.chatColor.chatRightBg
                            : theme.palette.chatColor.chatLeftBg,
                        // bgcolor: '#fff',
                        boxShadow: '0 1px 0.5px rgba(11,20,26,.13)',
                        borderBottom: message.error ? '1px solid #d32f2f' : 'none'
                      }}
                    >
                      {/* {message.sender_name && (
                        <NameLetter
                          nameLetter={message.sender_name}
                          nameType="text"
                        />
                      )} */}
                      {/* {message.sender_name && (
                        <Typography component={'div'} className="sender-name">
                          <Typography variant="span" component={'span'} className="nameAlias">
                          {wabaAliasConfig[message.waba_number]}
                          </Typography>
                        {message.sender_type === "user" ||
                          message.sender_type === "system" ?  <span className="name">{'(' +message.sender_name + ')'}</span> : null }</Typography>
                      )}     */}

                      {message.type === "document" && (
                        <>
                          {fileExtension(getDocName(message.url)) == 'pdf'?
                          <Box sx={{maxWidth: '300px' }}>                 
                           <Box className="attachment-blk" sx={{cursor:'pointer'}}>
                            <Box component="span" className="left" aria-label="Preview PDF"
                                onClick={()=> {setAttachmentModal(true);setOpenAttachment({url:message.url,type:message.type})}}>
                                <Avatar
                                  alt={fileExtension(getDocName(message.url))}
                                  src={getAttachmentIconVar(message.url)}
                                  variant="rounded"
                                />
                                <Box component={'span'}>
                                {message.url && <Typography
                              component="span"
                              className="chat-doc-info"
                              >{getDocName(message.url)} </Typography>}   
                              <Box>
                                <Typography component={'span'} className="note-text"><ExtensionIcon className="icon" /> {fileExtension(getDocName(message.url))}</Typography>
                                {message.file_size?
                                <Typography component={'span'} className="note-text"><ArticleIcon className="icon" /> {formatFileSize(message.file_size)}</Typography>:null}
                              </Box>
                              </Box>
                            </Box>

                              <IconButton
                                aria-label="Download"
                                onClick={()=>{
                                  handleDownload(message.url)
                                }}
                                className="attachment-url"
                                rel="noopener noreferrer"
                              >
                              <DownloadIcon />
                              </IconButton>        
                            </Box>
                        
                            {message.body && <Typography
                            sx={{ mt: 1 }}
                            component="div"
                            className="chat-conversation-msg"
                          >{message.body} </Typography>}
                          
                          </Box>:
                          <Box sx={{maxWidth: '300px' }} >
                           <Box className="attachment-blk" sx={{cursor:'pointer'}}>
                           <Box component="span" className="left"  aria-label="Download"
                              onClick={()=>{
                                handleDownload(message.url)
                              }}>
                              <Avatar
                                alt={fileExtension(getDocName(message.url))}
                                src={getAttachmentIconVar(message.url)}
                                variant="rounded"
                              />
                              <Box component={'span'}>
                              {message.url && <Typography
                            component="span"
                            className="chat-doc-info"
                          >{getDocName(message.url)} </Typography>}   

                          <Box>
                            <Typography component={'span'} className="note-text"><ExtensionIcon className="icon" /> {fileExtension(getDocName(message.url))?fileExtension(getDocName(message.url)):'Unknown'}</Typography>
                            {message.file_size?
                            <Typography component={'span'} className="note-text"><ArticleIcon className="icon" /> {formatFileSize(message.file_size)}</Typography>:null}
                          </Box>
                          </Box>
                          </Box>
                          <IconButton
                              href={message.url}
                              target="_blank"
                              className="attachment-url"
                              rel="noopener noreferrer"
                            >
                              <DownloadIcon />
                            </IconButton>  
                            </Box>                        
                                                   
                            {message.body && <Typography
                            sx={{ mt: 1 }}
                            component="div"
                            className="chat-conversation-msg"
                          >{message.body} </Typography>}
                          
                          </Box>}

                        </>
                      )}
                      {message.type === "image" && (
                        <>
                          {/* Concatenate message.body and message.url */}

                          {/* <img src={message.url} alt="Image" /> */}
                          <Box sx={{maxWidth: '300px'}} className="attch-media">
                          <Box sx={{ display: 'flex', alignItems: 'center', borderRadius: '5px', cursor:'pointer'}} >
                            <Box onClick={()=> {setAttachmentModal(true);setOpenAttachment({url:message.url,type:message.type})}}>
                          <ImageMessage url={message.url} size={formatFileSize(message.file_size)} extention={fileExtension(getDocName(message.url))}/>
                          </Box>
                          <IconButton 
                          aria-label="Download"
                          onClick={()=>{
                            handleDownload(message.url)
                          }                          }
                          >
                          <DownloadIcon />
                          </IconButton>
                          </Box>
                            {message.body &&  <Typography
                            sx={{ mt: 1 }}
                            component="div"
                            className="chat-conversation-msg"
                          >{message.body} </Typography>}
                          </Box>
                        </>
                      )}
                      
                      {message.type === "video" && (
                        <>
                          {/* Concatenate message.body and message.url */}
                          <Box sx={{maxWidth: '300px'}} className="attch-media">
                          <Box sx={{ display: 'flex', alignItems: 'center', borderRadius: '5px', cursor:'pointer'}} >
                            <Box onClick={()=> {setAttachmentModal(true);setOpenAttachment({url:message.url,type:message.type})}}>
                          <VideoMessage url={message.url} size={formatFileSize(message.file_size)} extention={fileExtension(getDocName(message.url))}/>
                          </Box>
                          <IconButton 
                          aria-label="Download"
                          onClick={()=>{
                            handleDownload(message.url)
                          }}
                          >
                          <DownloadIcon />
                          </IconButton>
                          </Box>
                            {message.body && <Typography
                            sx={{ mt: 1 }}
                            component="div"
                            className="chat-conversation-msg"
                          >{message.body}  </Typography>}
                         </Box>
                        </>
                      )}
                      {message.type === "audio" && (
                        <>
                          {/* Concatenate message.body and message.url */}
                          <Box sx={{maxWidth: '300px'}} className="attch-media">
                          <Box sx={{textAlign: 'center', marginBottom: '2px'}} onClick={()=> {setAttachmentModal(true);setOpenAttachment({url:message.url,type:message.type})}}>
                          <AudioMessage url={message.url} />
                          </Box>
                            {message.body && <Typography
                            sx={{ mt: 1 }}
                            component="div"
                            className="chat-conversation-msg"
                          >{message.body}  </Typography>}
                         </Box>
                        </>
                      )}
                      
                      {/* {message.type === "image" && <ImageMessage url={message.url} />} */}
                      {/* {message.type === "video" && <VideoMessage url={message.url} />} */}
                      {(message.type === "text" || message.type === "template") && (
                        <Typography
                          component="div"
                          className="chat-conversation-msg"
                          dangerouslySetInnerHTML={{ __html :message.body? message.body.replace(/\n/g,"<br />"):'' }}
                        >
                        </Typography>
                      )}
                      {message.type === "unsupported" && (
                        <Box className="unsupported-box" sx={{display: 'flex', alignItems:'center', color:red[500]}}>
                        <ReportGmailerrorredIcon className="unsupported-icon" sx={{marginRight: '2px'}} />
                        <Typography
                          component="div"
                          className="chat-conversation-msg"
                          sx={{fontStyle: 'italic', color: '#6b6b6b'}}
                          dangerouslySetInnerHTML={{ __html :message.body?"This message is " +message.body.replace(/\n/g,"<br />"):'' }}
                        >
                        </Typography>
                        </Box>
                      )}
                      {(message.type === "interactive" || message.type === "button" || message.type === "button_type") && (
                        <Typography
                          component="div"
                          className="chat-conversation-msg"
                          dangerouslySetInnerHTML={{ __html : message.body.replace(/\n/g,"<br />") }}
                        >
                        </Typography>
                      )}
                        <Typography
                        sx={{
                          fontSize: ".9rem",
                          display: "flex",
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          color: theme.palette.customColor.textDark,
                          marginTop:'2px'
                        }}
                        className="timeStamp"
                        component="div"
                        // color="#595959"
                      >
                         
                        <TimestampConverter
                          time={message.created_at}
                          callFrom="chatHistory"
                        />
                        {message.error ? (
                          <LightTooltip
                            title={<span style={{color: '#d32f2f', fontSize: '12px', fontWeight: 400}}>{typeof message.error === 'string' ? message.error : 'Message not sent'}</span>}
                            placement="top"
                            enterTouchDelay={0}
                            leaveTouchDelay={3000}
                          >
                            <IconButton size="small" aria-label={typeof message.error === 'string' ? message.error : 'Message not sent'} sx={{padding: '2px', marginLeft: '2px'}}>
                              <InfoIcon sx={{fontSize: {xs: '1.6rem', sm: '1.5rem'}, color: '#d32f2f'}} />
                            </IconButton>
                          </LightTooltip>
                        ) : null}
                      </Typography> 
                      {(message.type == 'document' || message.type == 'image' || message.type == 'video' || message.type == 'audio') && message.file_id ?
                        <Typography component={'div'} sx={{display:'flex', justifyContent: 'center'}}>
                        <Button variant="text" size="small" sx={{textTransform: 'capitalize'}} onClick={() => processUploadFile(message.file_id,message.url)}>
                        <CloudUploadIcon style={{ marginRight: '5px' }} />
                        <span>Upload this file to lead</span></Button></Typography>:null}                    
                    </Item>
                    </>
                    }
                  </Grid>
                </Grid>
                </>
              ))}
            </InfiniteScroll>
          ):
             <Box className="noChat-blk inn">
                <Box className="small-blk" sx={{backgroundColor: theme.palette.customColor.editorBG}}>
                <Avatar  sx={{boxShadow: 1, bgcolor: lightBlue[50], width: '85px', height: '85px', margin: '0 auto' }}>
                <CommentsDisabledOutlinedIcon sx={{fontSize: '5rem', color: lightBlue[500]}} /></Avatar>
                  <div>
                    <Typography sx={{ mt: 1, fontSize: '1.6rem'  }}  component="div">
                    No conversations available for this number
                    </Typography>
                  </div>
                  </Box>
            </Box>
            
            
        )}
      </Box>
      <Box component={'div'} className={`template-blk ${templateModel ?  'active' : "" } ${parseInt(appTheme) == 3 ?'dark':''}`}>
      <Box component={'div'} className="blk-inn">
      {templateModel?
      <>
        <Box className={`file-content-blk`} sx={{backgroundColor: `${darkTheme == 3 ? theme.palette.customColor.default : theme.palette.customColor.light}`}}>
          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography component={'div'} variant="h5" display={'flex'} alignItems={'center'} className="template-heading">Select Template  <LightTooltip  title="In-session: Send marketing, utility, and canned templates to address repetitive queries and foster engagement.
            Out-of-session: Utilize utility or marketing templates to engage and encourage students participation." placement="right"><InfoIcon className='templateInfotip' sx={{marginLeft: '4px', color: '#707070', fontSize: '2rem'}} /></LightTooltip></Typography>  
        <IconButton type="button"  onClick={()=>{setTemplateModel(false);
        triggerGtmAction('Template Cross Window')
              setTemplatePreview(null);
              setTemplateData(null);
              // setTemplateHtml(null);
              // setTemplateMediaName(null);
              }}>
            <CloseIcon />
          </IconButton>
        </Box>  

            {templateLoder? <Card className="template-view" sx={{display:'flex', alignItems: "center", justifyContent: "center"}}> 
              <CircularProgress size={35} />
            </Card>:
            <Grid container spacing={2}>
        <Grid item xs md={4}>
    
          <Paper
               component="form"
               sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
            >
              <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
            <SearchIcon />
              </IconButton>
            <InputBase
            onFocus={fucosOnTemplateSearch}
               sx={{ width: '100%' }}
               placeholder="Search Template"
              inputProps={{ 'aria-label': 'Search Template' }}
              onChange={handleSearchChange}
              autoFocus={window.innerWidth > 767 ?true:false}
              onKeyDown={(e)=>{ ;
                 handleEnterTemplateSearch(e)
                }}
               />
              </Paper>
              <Paper className="tempList-outer" id="template-list-block"> 
          <List className="tempList" id="templates-List">
       
          { 
               templateList.length > 0 ?getTemplateList()
              : (<NoDataFound />)
            }
            {
              searchTemplateNoData?(<NoDataFound text="No data found match to your search" />):null
            }
        </List>
        </Paper>
       </Grid>
        <Grid item xs={12} md={8} sx={{pb: 2}}>
        <Card className="template-view"> 
          <CardContent className="inn">
          {templateData && templateData.html ?<Typography
                          component="div"
                          className="chat-conversation-msg"
                          dangerouslySetInnerHTML={{ __html : (templateData.html).replace(/\n/g,"<br />") }}
                        >
                        </Typography>: <NoDataFound text={"No Template Selected"} />}
          </CardContent>
       </Card>
       <Box sx={{display:'flex', alignItems: 'center', justifyContent:'flex-end', mt:2}}>
       {wabaNos.length>0?
              <FormControl sx={{ mr: 1, width: '100px' }} size="small" className="selectBox head">
                 <InputLabel id="demo-simple-select-label">Reply Via</InputLabel>
              <Select
                 labelId="demo-simple-select-label"
                 id="demo-simple-select"
                value={selectedWabaNo?selectedWabaNo:" "}
                 label="Reply Via"
                 placeholder="Select Whatapp No."
                 onChange={(e)=>{
                  triggerGtmAction('Reply')
                  var obj=e.target
                  wabaNos.forEach(element => {
                    if(element.business_number == e.target.value){
                      setSession(element.session);
                      if(tempWabaNo == e.target.value){
                        setSession(tempSession);
                      }
                    }
                   });
                  setSelectedWabaNo(e.target.value == " "?e.target.value.trim():e.target.value);
                 }}
              ><MenuItem value=" ">
              Select
            </MenuItem>
                {templatePreview && templatePreview.template_category == 'canned'? getWabaNoOptions(true,false,true) :getWabaNoOptions(true)} 
              </Select> </FormControl>:null}


        {/* {templatePreview && templatePreview.template_category == 'canned'?
       <Button variant="contained" onClick={selectTemplate} disabled={templatePreview && templatePreview ? false : true}>Select</Button>
       : <Button variant="contained" 
       sx={{minWidth: 50,width:50,  height: 50, borderRadius: '100%'}}
       onClick={sendtemplate}
        disabled={templatePreview && templatePreview ? false : true}><SendIcon /></Button>
                } */}
          { <Button variant="contained" 
       sx={{minWidth: 50,width:50,  height: 50, borderRadius: '100%'}}
       onClick={sendtemplate}
        disabled={templatePreview && templatePreview ? false : true}><SendIcon /></Button>
                }
       </Box>
                
        </Grid>

          </Grid>}
          
              </Box>
              </>
              :null}               
              </Box> 
              </Box>
              <div className={`upload-file ${uploadModel ?  'active' : "" } ${parseInt(appTheme) == 3 ?'dark':''}`}>
              <Box component={'div'} className="blk-inn">
      {uploadModel?
      <>
          <Box className={`file-content-blk`} sx={{backgroundColor: `${darkTheme == 3 ? theme.palette.customColor.default : theme.palette.customColor.light}`}}>

          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography component={'div'} variant="h5" display={'flex'} alignItems={'center'} className="template-heading">Select Field </Typography>  
        <IconButton type="button"  onClick={()=>{setUploadModel(false);
          setUploadFields('');
          setUploadFileInfo('');
          setSelectedUploadField('');
          setFileUrl('');
          }}>
            <CloseIcon />
          </IconButton>
          </Box>  
            {/* {templateLoder? <Card className="template-view" sx={{display:'flex', alignItems: "center", justifyContent: "center"}}> 
              <CircularProgress size={35} />
            </Card>:
            } */}
            {showUploadFields()}

            <Box component={'div'} sx={{display: 'flex', mt: 2, justifyContent: 'flex-end'}}>
              <Box sx={{position: 'relative'}}>
                <Button
                role={'button'}
                variant="contained"
                sx={{textTransform: 'capitalize'}}
                startIcon={<CloudUploadIcon />}
                disabled ={uploadLoader ? uploadLoader : selectedUploadField?false:true}
                onClick={uploadFileToLm}
              >
                Upload file
              </Button>
              {uploadLoader == true &&
              <CircularProgress
                size={24}
                sx={{
                  color: blue[500],
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              /> }
              </Box>
              </Box>
          
              </Box>
              </>
              :null} 
             </Box>
              </div> 
              {echoStatus && (echoStatus== echoTabName.Niaa || echoStatus == echoTabName.Queued || echoStatus ==  echoTabName.Resolve || echoStatus == echoTabName.AutoResolve)?
              <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: theme.palette.customColor.default}} className="chat-interviene">
              <Button sx={{textTransform: 'capitalize', fontSize: '1.5rem'}} variant="contained" size={callBy == callByItems.widgetLead?"small":"large"} onClick={()=>{changeEchoStatus(echoTabName.Picked ,'intervened')}} disabled={statusChangeLoading}>{echoStatusButton[echoStatus]}</Button>
              </Box>:
            <div>
             {/* <Modal
                open={attachmentModal}
                onClose={handleAttachmentClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
              >

                <Box>

                <img
      className="d-block m-auto"
        srcSet=""
        src=""
        alt={"Image Name"}
        loading="lazy"
      />
                  
                </Box>
              </Modal>  */}

<Dialog
     open={attachmentModal}
     keepMounted
     onClose={()=>{setAttachmentModal(false);
      setOpenAttachment({});}}
     aria-describedby="alert-dialog-slide-description"
      fullScreen
      PaperProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Dark background
          boxShadow: 'none',
        },
      }}
    >
      <DialogContent
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 0,
        }}
      >
        
        <Box sx={{display:'flex', p: 2, position: 'absolute', top: 0, width: '100%', justifyContent: 'flex-end'}}>
        <IconButton
          aria-label="Download"
          id="download-attachment"
          sx={{ color: "#fff" }}
          onClick={()=>{
            handleDownload(openAttachment.url)
          }
          }
        >
          <DownloadIcon />
        </IconButton>

          <IconButton
          aria-label="Close"
          onClick={()=>{setAttachmentModal(false);
            setOpenAttachment({});}}
          sx={{color: "#fff"}}
        >
          <CloseIcon />
        </IconButton>
        </Box>
        {openAttachment.type == 'image' &&
          <img
            src={openAttachment.url}
            loading="lazy"
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '75%',
            }}
          />
        }
        {openAttachment.type == 'document' &&
          <iframe
          src={`${openAttachment.url}#toolbar=0`}
          style={{ width: '100%', height: '100%', border: 'none' }}
            title="PDF Preview"
          />
        }
        {openAttachment.type == 'video' &&
        <Box component={'div'} className="video-box">
         <video controls className="modalVideo" autoPlay="true">
            <source src={openAttachment.url} type="video/mp4" />
         </video>
        </Box>
        }
        {/* {openAttachment.type == 'audio' &&
          <audio controls style={{ width: '100%' }}>
          <source src={openAttachment.url} type={openAttachment.type} />
          Your browser does not support the audio element.
        </audio>
        } */}
      </DialogContent>
    </Dialog>

            

              {echoEnabled && (checkAnyEnableNo || isLoading)?
              <div>
              <Box sx={{display: 'flex', backgroundColor: theme.palette.customColor.default}} className={`editor-blk`} id='editor-block'>
              
              {!isLoading?
              <FormControl sx={{ mr: 1, width: '100px' }} size="small" className="selectBox foot" >
               <InputLabel id="demo-simple-select-label">Reply via</InputLabel>
              <Select
                 labelId="demo-simple-select-label"
                 id="demo-simple-select"
                 label="Reply via"
                 value={selectedWabaNo?selectedWabaNo:" "}
                 placeholder="Reply via"
                 MenuProps={{
                  PaperProps: {
                    sx: {
                      position: 'fixed !important', 
                      top: 'auto !important',
                      bottom: '70px'
                    }
                  }
                }}
                 onChange={(e)=>{
                  var obj=e.target
                  wabaNos.forEach(element => {
                    if(element.business_number == e.target.value){
                      setSession(element.session);
                      if(tempWabaNo == e.target.value){
                        setSession(tempSession);
                      }
                    }
                   });
                  setSelectedWabaNo(e.target.value == " "?e.target.value.trim():e.target.value);
                 }}
              ><MenuItem  key={'select-default'} value=" ">
              Select
            </MenuItem>
                {getWabaNoOptions(true)} 
              </Select> </FormControl>:null}

      {isLoading ? (
        <Stack direction={"row"} alignItems="center" spacing={2} sx={{width: '100%'}}>
          
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="rectangular" sx={{width: 'calc(100% - 100px)'}} height={60} />
          <Skeleton variant="circular" width={40} height={40} />
        </Stack>
      ) : session ? (
          
        <form encType="multipart/form-data" onSubmit={handleFormSubmit} className="msg-input-form">
    
          <Stack direction={"row"} alignItems="center" spacing={2} className={` ${templateModel? 'active' : ""}`}>
            
            
            <Paper
              sx={{
                display: "flex",
                alignItems: "flex-end",
                width: "100%",
                borderColor: theme.palette.customColor.editorBG,
                // position: 'relative',
                boxShadow: 'rgba(11, 20, 26, 0.13) 0px 1px 0.5px',
                // overflow: 'hidden',
                padding: mobileMatches? '.5rem' : '1rem',
                borderRadius:"8px"
              }}
              
            >

              <div>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                sx={{ backgroundColor: "rgba(0,0,0,.2)" }}
                onClick={handleClick}
                disabled={templateModel}
              >
                <AddIcon />
              </IconButton>

              <Menu
                id="long-menu"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    // width: "20ch",
                  },
                  sx: {
                    position: 'fixed !important', 
                    top: 'auto !important',
                    bottom: '70px'
                  },
                }}
                disabled={templateModel}
              >
                <MenuItem onClick={handleDocumentUploadToLm}>
                  <input
                    type="file"
                    ref={fileInputRefAttachment}
                    style={{ display: "none" }}
                    onChange={handleLmFileChange}
                  />
                  <ListItemIcon>
                    <CloudUploadIcon sx={{ color: indigo[500] }} />
                  </ListItemIcon>
                  Upload file to Lead
                </MenuItem>
                <MenuItem onClick={templateModelOpen}>
                  <ListItemIcon>
                    <AssignmentIcon sx={{ color: green[500] }} />
                  </ListItemIcon>
                   Templates
                </MenuItem>
                <MenuItem onClick={handleDocumentUpload}>
                  <input
                    type="file"
                    ref={fileInputRefDoc}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <ListItemIcon>
                    <DocumentScannerIcon sx={{ color: deepOrange[500] }} />
                  </ListItemIcon>
                  Document
                </MenuItem>
                <MenuItem onClick={handleImgUpload}>
                  <input
                    type="file"
                    ref={fileInputRefImg}
                    style={{ display: "none" }}
                    onChange={handleImgChange}
                  />
                  <ListItemIcon>
                    <AddPhotoAlternateIcon sx={{ color: cyan[500] }} />
                  </ListItemIcon>
                  Image
                </MenuItem>
                <MenuItem onClick={handleVidUpload}>
                  <input
                    type="file"
                    ref={fileInputRefVid}
                    style={{ display: "none" }}
                    onChange={handleVidChange}
                  />
                  <ListItemIcon>
                    <VideoCameraBackIcon sx={{ color: amber[500] }} />
                  </ListItemIcon>
                  Video
                </MenuItem>
              </Menu>
            </div>
              {sendDisabled == true ?
              <Box className="send-msg-loader">
                <CircularProgress size={mobileMatches ? 25 : 35} />
              </Box>
              : ""}
              {binaryData && (
                <Stack direction="row" className={`dataChip`} spacing={1}>
                  <Chip
                    avatar={
                      messageType === "image" ? (
                        <AddPhotoAlternateIcon />
                      ) : messageType === "document" ? (
                        <DocumentScannerIcon />
                      ) : messageType === "video" ? (
                        <VideoCameraBackIcon />
                      ) : null
                    }
                    size="small"
                    label={binaryData.name}
                    // label={matches ? binaryData.name : ""}
                    deleteIcon={<ClearIcon />}
                    onDelete={handleBinaryDelete}
                    sx={{ padding: "3px",backgroundColor: `${darkTheme == 3 ? theme.palette.customColor.default : theme.palette.customColor.light}`
                  }}
                  />
                </Stack>
              )}
{/* 
              {templateMediaName && (
                <Stack direction="row" spacing={1}>
                  <Chip
                    avatar={
                      messageType === "image" ? (
                        <AddPhotoAlternateIcon />
                      ) : messageType === "document" ? (
                        <DocumentScannerIcon />
                      ) : messageType === "video" ? (
                        <VideoCameraBackIcon />
                      ) : null
                    }
                    size="small"
                    label={templateMediaName }
                    deleteIcon={<ClearIcon />}
                    // onDelete={()=>{setTemplateMediaName(null)}}
                    sx={{ padding: "3px" }}
                  />
                </Stack>
              )} */}
              <TextField
                sx={{ ml: 1, flex: 1, p: 1, minHeight: 40 }}
                inputRef={inputRef}
                placeholder={mobileMatches ?'Type here...': "Type here or start with '/' to select a template..."}
                onChange={(event) => {
                  typingHandler(event);
                  let content = handleSlash(event)
                  setMessage(content);

                  if (content.length > 0) {
                    setEnterShow(true);
                  } else {
                    // setTemplateData(null);
                    // setSelectedTemplate(null);
                    // setTemplatePreview(null);
                    setEnterShow(false);
                  }
                }}
                onKeyUp={handleInputKeyup}
                value={message}
                onKeyDown={handleEnterPress}
                onCut={handleCut}
                disabled={sendDisabled || templateModel}
                multiline="true"
                className="editor-text"
              />
              {/* <textarea
                inputRef={inputRef}
                placeholder="Type Here..."
                onChange={(event) => {
                  typingHandler(event);
                  let content = event.target.value;
                  setMessage(content);

                  if (content.length > 0) {
                    setEnterShow(true);
                  } else {
                    setEnterShow(false);
                  }
                }}
                value={message}
                onKeyPress={handleEnterPress}
              ></textarea> */}
              {/* <div
                className="editable-div"
                contentEditable="true"
                role="textbox"
                spellCheck="true"
                title="Type a message"
                onInput={(event) => {
                  typingHandler(event);
                  let content = event.target.innerText;
                  setMessage(content);

                  if (content.length > 0) {
                    setEnterShow(true);
                  } else {
                    setEnterShow(false);
                  }
                }}
                value={message}
                onKeyDown={handleEnterPress}
              ></div> */}
              {istyping && (
                <Typography
                  sx={{
                    color: theme.palette.text.secondary,
                  }}
                  className="typing-text"
                >
                  typing...
                  {listening ? "listening..." : ""}
                </Typography>
              )}

              <Stack component={"div"}  sx={{ml:2}}>
              {!browserSupportsSpeechRecognition || enterShow ? (
                <IconButton sx={{ p: 1 }} disabled={sendDisabled} onClick={() => {
                  setSendDisabled(()=>true)
                  triggerGtmAction('Send')
                  sendMessage1()
                  }}>
                  {/* <IconButton sx={{ p: 1 }} type="submit"> */}
                  <SendIcon />
                </IconButton>
              ) : (
                <IconButton
                  sx={{ p: 1 }}
                  onClick={clickMic}
                  className={`${listening ? "blinker blinker-muted" : ""}`}
                  disabled={templateModel}
                >
                  <MicIcon />
                </IconButton>
              )}
            </Stack>


            </Paper>
           
              
            
          </Stack>
          
        </form>
      ) : (
        <Stack direction={"row"} spacing={2} sx={{width: '100%'}}>
          
          <Paper
            sx={{
              boxShadow: 0,
              width: "100%",
              height: "50px",
              
              bgcolor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            className="editor-no-session"
          >
            <AnnouncementIcon className="icon" sx={{fontSize: '4rem', mr: 1, color: "#999"}} />
            <Box component={'div'}><Typography component={'span'}>User is not in session.</Typography>
              <Button className="uploadFileBtn" onClick={handleDocumentUploadToLm} sx={{textTransform:'capitalize'}}>
                  <input
                    type="file"
                    ref={fileInputRefAttachment}
                    style={{ display: "none" }}
                    onChange={handleLmFileChange}
                  />
                  Upload file to Lead 
                </Button>
                <Typography component={'span'} className="spacer">or</Typography>
               <Button className="sendTemplateBtn" onClick={()=>{
                                triggerGtmAction('Send a template instead')
              setTemplateModel(!templateModel); setTemplateData(null);
              // setTemplateHtml(null);
              // setSelectedTemplate(null);
              setMessage('');
              setEnterShow(false);}} sx={{textTransform:'capitalize'}}> Send a template instead
              </Button></Box>
          </Paper>
         
             </Stack>
           )}


          
              
              </Box></div>:
                            <Box sx={{display: 'flex'}} className={`editor-blk`} id='editor-block'>

              <Stack direction={"row"} spacing={2} sx={{width: '100%'}}>
          
          <Paper
            sx={{
              boxShadow: 0,
              width: "100%",
              height: "50px",
              
              bgcolor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <AnnouncementIcon sx={{fontSize: '4rem', mr: 1, color: "#999"}} />
            <Typography className="not-enable" sx={{lineHeight: '1.2', color: theme.palette.customColor.textDark}}>Oops! It looks like there are no WhatsApp Business numbers enabled for Echo to support your students. Please contact account representative.</Typography>
          </Paper>
         
             </Stack>
             </Box>}
              </div>}
    </>
    
  );
}
